//import companyData from "../assets/styles/theme.json";
import OAuth2 from "fetch-mw-oauth2";
import Cookies from "universal-cookie";
import Emitter from "../utils/event-emitter";
import {
  isPaymentPortalUser,
  MG_CONSUMER_LOGIN_ROUTE,
  getPostSignOutLoginPath,
} from "./constatnts";

// let api = "http://0548-137-59-64-76.ngrok.io";
let api = process.env.REACT_APP_API_URL;
// let api = 'http://4296-1-23-77-216.ngrok.io' //TO_DO
let clientID = process.env.REACT_APP_OAUTH_CLIENT_ID;
let clientSecret = process.env.REACT_APP_OAUTH_CLIENT_SECRET;

let oauth2;
let oauthGeneration = 0;

export const getBaseUrl = () => {
  return window.location.origin;
  // return "https://mgstage.accountpayonline.com";
};

const cookies = new Cookies();
const cookiePathOpts = { path: "/", secure: true };

let paymentPortalAuthErrorEmitted = false;

const isValidToken = (token) =>
  token != null && token !== "" && token !== "null";

const canUseOauthRefresh = () =>
  Boolean(
    cookies.get("authUser") &&
      cookies.get("isLoggedIn") &&
      isValidToken(cookies.get("accessToken", cookiePathOpts)) &&
      isValidToken(cookies.get("refreshToken", cookiePathOpts))
  );

const shouldEmitOauthError = () => {
  const loginPath = getPostSignOutLoginPath(
    cookies.get("authUser", cookiePathOpts)
  );
  const path = window.location.pathname;
  return (
    path !== loginPath &&
    path !== "/login" &&
    path !== MG_CONSUMER_LOGIN_ROUTE &&
    path !== "/sign-out"
  );
};

const emitOauthError = () => {
  if (!shouldEmitOauthError()) return;
  Emitter.emit(
    "OAUTH_ERROR",
    getPostSignOutLoginPath(cookies.get("authUser", cookiePathOpts))
  );
};

const isUnauthorizedApiResponse = (response, data) => {
  if (response?.status === 401) return true;
  if (!data || typeof data !== "object") return false;
  return data.status_code === 401 || data.status === 401;
};

/** Plain-fetch fallback when no refresh token (payment portal without refresh). */
const shouldHandlePaymentPortalAuthError = () => {
  const authUser = cookies.get("authUser", cookiePathOpts);
  if (!cookies.get("isLoggedIn", cookiePathOpts)) return false;
  if (!isPaymentPortalUser(authUser)) return false;
  if (canUseOauthRefresh()) return false;
  const path = window.location.pathname;
  return (
    path !== MG_CONSUMER_LOGIN_ROUTE &&
    path !== "/login" &&
    path !== "/sign-out"
  );
};

const emitPaymentPortalAuthError = () => {
  if (paymentPortalAuthErrorEmitted || !shouldHandlePaymentPortalAuthError()) {
    return;
  }
  paymentPortalAuthErrorEmitted = true;
  Emitter.emit("OAUTH_ERROR", MG_CONSUMER_LOGIN_ROUTE);
};

const wrapResponseForAuthCheck = (response) => {
  if (response.status === 401) {
    emitPaymentPortalAuthError();
  }
  const originalJson = response.json.bind(response);
  response.json = () =>
    originalJson().then((data) => {
      if (isUnauthorizedApiResponse(response, data)) {
        emitPaymentPortalAuthError();
      }
      return data;
    });
  return response;
};

const fetchWithAuthHandling = (url, fetchOptions) =>
  fetch(url, fetchOptions).then(wrapResponseForAuthCheck);

/** Plain fetch passthrough — headers from setHeaders() are used as-is (no stale OAuth middleware). */
const createPlainFetchClient = () => ({
  fetch: fetchWithAuthHandling,
});

const syncTokensToCookies = (token, gen) => {
  if (gen !== oauthGeneration) return;
  cookies.remove("accessToken", cookiePathOpts);
  cookies.remove("refreshToken", cookiePathOpts);
  cookies.set("accessToken", token.accessToken, cookiePathOpts);
  cookies.set("refreshToken", token.refreshToken, cookiePathOpts);
  const authUser = cookies.get("authUser", cookiePathOpts);
  if (authUser && typeof authUser === "object") {
    cookies.set(
      "authUser",
      {
        ...authUser,
        user_auth_token: token.accessToken,
        user_refresh_token: token.refreshToken,
      },
      cookiePathOpts
    );
  }
};

const createOauth2Client = (accessT, refreshT) => {
  oauthGeneration += 1;
  const gen = oauthGeneration;
  oauth2 = new OAuth2(
    {
      clientId: clientID,
      clientSecret: clientSecret,
      tokenEndpoint: `${api}/oauth/token?organization_key=${getBaseUrl()}`,
      onAuthError: () => emitOauthError(),
      onTokenUpdate: (token) => syncTokensToCookies(token, gen),
    },
    {
      accessToken: accessT,
      refreshToken: refreshT,
    }
  );
};

/** Initialize OAuth2 refresh client from cookies (admin + payment portal when refresh token exists). */
export const initOauth2ClientFromCookies = () => {
  paymentPortalAuthErrorEmitted = false;
  if (!canUseOauthRefresh()) {
    oauthGeneration += 1;
    oauth2 = createPlainFetchClient();
    return;
  }
  createOauth2Client(
    cookies.get("accessToken", cookiePathOpts),
    cookies.get("refreshToken", cookiePathOpts)
  );
};

/** Drop admin OAuth2 client still held in memory after logout or payment-portal login. */
export const resetOauth2Client = () => {
  oauthGeneration += 1;
  paymentPortalAuthErrorEmitted = false;
  oauth2 = createPlainFetchClient();
};

export const clearAuthTokenCookies = () => {
  ["accessToken", "refreshToken", "authUser", "isLoggedIn"].forEach((key) => {
    cookies.remove(key, cookiePathOpts);
    cookies.remove(key, { path: "/" });
  });
};

/** Reset in-memory OAuth client, then clear auth cookies (order matters). */
export const beginFreshSession = () => {
  resetOauth2Client();
  clearAuthTokenCookies();
};

if (canUseOauthRefresh()) {
  createOauth2Client(
    cookies.get("accessToken", cookiePathOpts),
    cookies.get("refreshToken", cookiePathOpts)
  );
} else {
  oauth2 = createPlainFetchClient();
}

const setHeaders = (user, useAuth, useJSON, newOrgKey) => {
  const themeData = localStorage.getItem("themeData");
  const theme = themeData ? JSON.parse(themeData) : null;
  const orgKey = newOrgKey
    ? newOrgKey
    : theme && theme.organization_key
      ? theme.organization_key
      : user && user.organization_key
        ? user.organization_key
        : null;

  const authuser = cookies.get("accessToken", cookiePathOpts);

  let headerObj = {};

  // Set Organization-Key if available
  if (orgKey) {
    headerObj["Organization-Key"] = orgKey;
  }

  // Set Authorization header if useAuth is true
  if (useAuth || user) {
    const bearer = authuser || user?.user_auth_token;
    if (isValidToken(bearer)) {
      headerObj["Authorization"] = `Bearer ${bearer}`;
    }
  }

  // Set Content-Type to JSON if required
  if (useJSON) {
    headerObj["Content-Type"] = "application/json";
  }
  return headerObj;
};

export const setOauthObj = (payload) => {
  let base_url = window.location.origin;
  // let base_url = "https://mgstage.accountpayonline.com";

  if (
    // (payload.email != "null" && payload.email != null && payload.email != "") ||
    // (payload.password != "null" &&
    //   payload.password != null &&
    //   payload.password != "")
    true
  ) {
    oauthGeneration += 1;
    const gen = oauthGeneration;
    oauth2 = new OAuth2({
      grantType: "password",
      clientId: clientID,
      clientSecret: clientSecret,
      userName: payload.email,
      password: payload.password,
      tokenEndpoint: `${api}/oauth/token?organization_key=${getBaseUrl()}`,
      onTokenUpdate: (token) => syncTokensToCookies(token, gen),
      onAuthError: () => emitOauthError(),
    });
  } else {
    // window.location.href = "/login";
  }
};

// ---- SESSION CONTROL ----
export const signup = (userCanidate) =>
  oauth2
    .fetch(`${api}/users`, {
      method: "POST",
      headers: setHeaders(null, false, true),
      body: JSON.stringify({
        user: {
          ...userCanidate,
        },
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateUser = (user, userUpdate) =>
  oauth2
    .fetch(`${api}/users/${user.user_id}`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        user: {
          ...userUpdate,
        },
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateAdminPassword = (user, adminID, passowrd) => {
  return oauth2
    .fetch(`${api}/admin/setPassword`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        admin_id: adminID,
        password: passowrd,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getUserbackend = (user) =>
  oauth2
    .fetch(`${api}/version`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateOnboardingPercentage = (user, percent) =>
  oauth2
    .fetch(
      `${api}/client/org/update_onboard_percent?onboarding_percentage=${percent}`,
      {
        method: "PUT",
        headers: setHeaders(user, true, false),
      }
    )
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendInvoicesToCollection = (user, accountId, invoiceList) =>
  oauth2
    .fetch(
      `${api}/client/invoice/placeToCollections?invoice_ids=${invoiceList}&&user_id=${accountId}`,
      {
        method: "POST",
        headers: setHeaders(user, true, false),
      }
    )
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });
export const getRegisterationCode = (payload) =>
  oauth2
    .fetch(
      `${api}/users/send_reg_token?org_key=${payload.org_key}&&email=${payload.email}`,
      {
        method: "POST",
        headers: setHeaders(null, false, false),
        // body: JSON.stringify({ ...payload }),
      }
    )
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getLogoColors = (user) =>
  oauth2
    .fetch(`${api}/logoColors?org_url=${getBaseUrl()}`, {
      method: "GET",
      // headers: setHeaders(null, true, false),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const verifyUserExistence = (user, email) =>
  oauth2
    .fetch(`${api}/users/validate_user?email=${email}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getLogoColorsForPayment = (key) =>
  oauth2
    .fetch(`${api}/logoColors?org_url=${getBaseUrl()}`, {
      method: "GET",
      // headers: setHeaders(null, true, true),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getTestCreds = (user, pathVariable) =>
  oauth2
    ?.fetch(
      `${api}/client/organization/get_test_creds?full_portal=${pathVariable}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    ?.then((res) => res.json())
    ?.catch((error) => {
      console.error("error==========:", error);
    });

export const getUser = (user) =>
  oauth2
    .fetch(`${api}/users/${user.user_id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const confirmAccount = (user, smsCode) =>
  oauth2
    .fetch(`${api}/users/${user.user_id}/confirm`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        sms_code: smsCode,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const acceptUserAgreement = (user, accepted) => {
  const theme1 = JSON.parse(localStorage.getItem("switchOrgDetails"));
  const orgKey1 = theme1 && theme1.organization_key;

  const theme2 = JSON.parse(localStorage.getItem("themeData"));
  const orgKey2 = theme2.organization_key;
  let orgKey = orgKey1 ? orgKey1 : orgKey2;
  let userID = user.id || user.user_id;
  return oauth2
    .fetch(`${api}/users/${userID}/agreement`, {
      method: "POST",
      headers: setHeaders(user, true, true, orgKey),
      body: JSON.stringify({
        accepted: accepted,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const checkInvoiceDuplicacy = (user, invoiceNumber, invoiceId) => {
  return oauth2
    .fetch(
      `${api}/client/invoice/validate?invoice_id=${invoiceId}&invoice_number=${invoiceNumber}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const login = (user) =>
  oauth2
    .fetch(`${api}/sessions`, {
      method: "POST",
      headers: setHeaders(user, false, true),
      body: JSON.stringify({
        session: {
          email: user.email,
          password: user.password,
          organization_key: user.organization_key,
          sub_id: user.sub_id,
          openid_id: user.openid_id,
        },
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      if (error && error.message != "Failed to fetch") {
        return { errors: error.message };
      }
    });
export const ssoLogin = (user) => {
  return oauth2
    .fetch(`${api}/sso_session`, {
      method: "POST",
      headers: setHeaders(user, false, true, user.organization_key),
      body: JSON.stringify({
        session: {
          email: user.email,
          password: user.password,
          organization_key: user.organization_key,
          sub_id: user.sub_id,
          openid_id: user.openid_id,
        },
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      if (error && error.message != "Failed to fetch") {
        return { errors: error.message };
      }
    });
};

export const searchByEverything = (user, searchTerm) => {
  return oauth2
    .fetch(`${api}/client/search/all?q=${searchTerm}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};
export const ssoLoginForQB = (user) =>
  oauth2
    .fetch(`${api}/sso_session`, {
      method: "POST",
      headers: setHeaders(user, false, true),
      body: JSON.stringify({
        session: {
          email: user.email,
          password: user.password,
          organization_key: user.organization_key,
          sub_id: user.sub_id,
          openid_id: user.openid_id,
        },
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      if (error && error.message != "Failed to fetch") {
        return { errors: error.message };
      }
    });

export const configureApp = (company_data) =>
  oauth2
    .fetch(`${api}/configureApp`, {
      method: "POST",
      headers: setHeaders(null, false, true),
      body: JSON.stringify({
        company_data,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const appThirdPartyConfig = (config_data) =>
  oauth2
    .fetch(`${api}/appThirdPartyConfig`, {
      method: "POST",
      headers: setHeaders(null, false, true),
      body: JSON.stringify({
        config_data,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const isAppConfigure = () =>
  oauth2
    .fetch(`${api}/isAppConfigured`, {
      method: "GET",
      headers: setHeaders(null, false, true),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const isThirdPartyAppConfigured = () =>
  oauth2
    .fetch(`${api}/isThirdPartyAppConfigured`, {
      method: "GET",
      headers: setHeaders(null, false, true),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAppInfo = () =>
  oauth2
    .fetch(`${api}/getAppInfo`, {
      method: "GET",
      headers: setHeaders(null, false, true),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAppConfigInfo = (organization_key) =>
  oauth2
    .fetch(`${api}/getAppConfigInfo?org_key=${organization_key}`, {
      method: "GET",
      headers: setHeaders(null, false, true),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const signout = (user) =>
  oauth2
    .fetch(`${api}/sign_out`, {
      method: "DELETE",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const passwordResetRequest = (email, key) =>
  oauth2
    .fetch(`${api}/passwords`, {
      method: "POST",
      headers: setHeaders({ organization_key: key }, false, true),
      body: JSON.stringify({
        password: {
          email: email,
        },
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const passwordReset = (user, passwordPayload) =>
  oauth2
    .fetch(`${api}/users/${passwordPayload.userID}/password`, {
      method: "PUT",
      headers: setHeaders(null, false, true),
      body: JSON.stringify(passwordPayload),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const unlockAccount = (user, adminID) =>
  oauth2
    .fetch(`${api}/admin/unlockAccount?admin_id=${adminID}`, {
      method: "PUT",
      headers: setHeaders(user, false, true),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const validateFileData = (user, payload) => {
  return oauth2
    .fetch(`${api}/client/consumer/validate_data`, {
      method: "POST",
      headers: setHeaders(user, true, false),
      body: payload,
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const importStatus = (user, type) => {
  return oauth2
    .fetch(`${api}/client/import_data/status?type=${type}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const importAccountData = (user, payload) => {
  return oauth2
    .fetch(`${api}/client/import_data/accounts`, {
      method: "POST",
      headers: setHeaders(user, true, false),
      body: payload,
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const importInvoiceData = (user, payload) => {
  return oauth2
    .fetch(`${api}/client/import_data/invoices`, {
      method: "POST",
      headers: setHeaders(user, true, false),
      body: payload,
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};
// ---- ADMIN::SEARCH ----

export const adminSearch = (user, context, query) =>
  oauth2
    .fetch(`${api}/admin/search/${context}?q=${query}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const adminOfferSearch = (user, context, offer_type, query) =>
  oauth2
    .fetch(`${api}/admin/search/${context}?type=${offer_type}&q=${query}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// ---- ADMIN::ADMINS ----
export const fetchAllAdmins = (user, organization_id) =>
  oauth2
    .fetch(`${api}/admin/admins?organization_id=${organization_id}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const DeleteOwner = (user, id) =>
  oauth2
    .fetch(`${api}/admin/owner/delete?id=${id}`, {
      method: "Delete",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const createAdmin = (user, adminCanidate) =>
  oauth2
    .fetch(`${api}/admin/organization/addAdmin`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...adminCanidate,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const resetAdminPassword = (user, adminId) =>
  oauth2
    .fetch(`${api}/admin/admins/${adminId}/reset_admin_password`, {
      method: "POST",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const deactivateAdmin = (user, adminId) =>
  oauth2
    .fetch(`${api}/admin/admins/${adminId}/deactivate`, {
      method: "POST",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// ---- ADMIN::CONSUMERS ----

export const fetchAllConsumers = (user) =>
  oauth2
    .fetch(`${api}/admin/consumers`, { headers: setHeaders(user, true, false) })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchAllPendingAddressConsumers = (user) =>
  oauth2
    .fetch(`${api}/admin/consumers/pendingAddressUser`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchDebtDetail = (user) =>
  oauth2
    .fetch(`${api}/consumer/debtDetailList`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getConsumer = (user, id) =>
  oauth2
    .fetch(`${api}/admin/consumers/${id}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getViewConsumerConversation = (user, id) =>
  oauth2
    .fetch(`${api}/admin/consumers/${id}/conversation`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getViewConsumerAddressDocument = (user, context, id) =>
  oauth2
    .fetch(`${api}/${context}/consumers/${id}/addressDocument`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const approveAddressDocument = (user, context, id) =>
  oauth2
    .fetch(`${api}/${context}/consumers/${id}/approveAddressDocument`, {
      method: "PUT",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const disableAccount = (user, accountID) => {
  return oauth2
    .fetch(`${api}/client/consumers/${accountID}/disable?is_disable=true`, {
      method: "PUT",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getClientConsumerById = (user, accountID) => {
  return oauth2
    .fetch(`${api}/client/consumers/${accountID}/details`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const rejectAddressDocument = (user, context, id) =>
  oauth2
    .fetch(`${api}/${context}/consumers/${id}/rejectAddressDocument`, {
      method: "PUT",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getCleintAdminUser = (user) => {
  let id = user.user_id || user.id;
  return oauth2
    .fetch(`${api}/users/${id}/client_admins`, {
      method: "GET",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getConsumerEdit = (user, consumer_id) =>
  oauth2
    .fetch(`${api}/admin/consumers/${consumer_id}/edit`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateConsumer = (user, consumer_id, consumer) =>
  oauth2
    .fetch(`${api}/admin/consumers/${consumer_id}`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        consumer,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const createConsumer = (user, consumer) =>
  oauth2
    .fetch(`${api}/admin/consumers/`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        consumer,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const createCreditor = (user, creditor) =>
  oauth2
    .fetch(`${api}/creditor/`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        creditor,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const deactivateConsumer = (user, consumer_id) =>
  oauth2
    .fetch(`${api}/admin/consumers/${consumer_id}/deactivate`, {
      method: "POST",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// ---- ADMIN::OFFERS ----

export const getPendingOffers = (user) =>
  oauth2
    .fetch(`${api}/admin/offers/`, { headers: setHeaders(user, true, false) })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getOfferList = (user, offer_type) =>
  oauth2
    .fetch(`${api}/admin/offers/getOfferList?offer_type=` + offer_type, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getPendingOffersCount = (user) =>
  oauth2
    .fetch(`${api}/admin/offers/pendingOffersCount`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const pendingActions = (user) =>
  oauth2
    .fetch(`${api}/admin/admins/pending_actions`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAdminOffer = (user, id) =>
  oauth2
    .fetch(`${api}/admin/offers/${id}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const adminAcceptOffer = (user, offerId) =>
  oauth2
    .fetch(`${api}/admin/offers/${offerId}/accept`, {
      method: "POST",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const adminCounterOffer = (user, offerId, offer) =>
  oauth2
    .fetch(`${api}/admin/offers/${offerId}/counter`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify(offer),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const adminRejectOffer = (user, offerId) =>
  oauth2
    .fetch(`${api}/admin/offers/${offerId}/reject`, {
      method: "POST",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// ---- ADMIN::CREDITORS ----

export const fetchAllCreditors = (user) =>
  oauth2
    .fetch(`${api}/creditors`, { headers: setHeaders(user, true, false) })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// ---- ADMIN::CREDITORS ----
export const uploadCSV = (user, csv) =>
  oauth2
    .fetch(`${api}/admin/debts/import`, {
      method: "POST",
      headers: setHeaders(user, true, false),
      body: csv,
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// ---- CONSUMER::DEBTS ----
export const fetchAllDebts = (user) =>
  oauth2
    .fetch(`${api}/consumer/debts`, { headers: setHeaders(user, true, false) })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getDebt = (user, id) =>
  oauth2
    .fetch(`${api}/consumer/debts/${id}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// ---- CONSUMER::OFFERS ----
export const getConsumerOffer = (user, id) =>
  oauth2
    .fetch(`${api}/consumer/offers/${id}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const consumerCreateOffer = (user, debtId, offer, stripeToken) =>
  oauth2
    .fetch(`${api}/consumer/debts/${debtId}/offers`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        offer: {
          ...offer,
        },
        stripe_token: stripeToken,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
// Client Accept Payment
export const getCardInfo = (user, userID) => {
  return oauth2
    .fetch(`${api}/client/card_info?user_id=${userID}`, {
      method: "GET",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getOrganizationList = (user) => {
  return oauth2
    .fetch(`${api}/client/organizations`, {
      method: "GET",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const addCardInfo = (user, payload, userID) => {
  return oauth2
    .fetch(`${api}/client/add_card?user_id=${userID}`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify(payload),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const removeCardInfo = (user, payload, userID) => {
  return oauth2
    .fetch(`${api}/client/delete_card?user_id=${userID}`, {
      method: "DELETE",
      headers: setHeaders(user, true, true),
      body: JSON.stringify(payload),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

// ---- CONSUMER::PAYMENTS ----
export const getCardPaymentConfirmation = async (intentID) => {
  try {
    const response = await oauth2.fetch(
      `${api}/check3ds?charge_id=${intentID}`,
      {
        method: "GET",
        headers: setHeaders(null, false, true),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("error==========:", error);
  }
};
export const settleAccountPayment = (user, stripeToken, debtID, amount) =>
  oauth2
    .fetch(`${api}/payment`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        debtID: debtID,
        cardToken: stripeToken,
        amount: amount,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// ----- CONSUMER::CUSTOMER ID -----
export const createOrUpdateStripeCustomerId = (
  user,
  stripeToken,
  sub_account_id
) =>
  oauth2
    .fetch(
      `${api}/consumer/consumerCardInfo?sub_account_id=${sub_account_id}`,
      {
        method: "POST",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({
          cardToken: stripeToken,
        }),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getConsumerCardList = (user) =>
  oauth2
    .fetch(`${api}/consumer/cards`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const removeCard = (user, payload, sub_account_id) =>
  oauth2
    .fetch(`${api}/consumer/removeCard?sub_account_id=${sub_account_id}`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const disconnectBank = (user, payload, sub_account_id) =>
  oauth2
    .fetch(
      `${api}/consumer/payment/disconnectBank?sub_account_id=${sub_account_id}`,
      {
        method: "POST",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({ ...payload }),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const consumerAcceptOffer = (user, offerId) =>
  oauth2
    .fetch(`${api}/consumer/offers/${offerId}/accept`, {
      method: "POST",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const consumerCounterOffer = (user, offerId, offer) =>
  oauth2
    .fetch(`${api}/consumer/offers/${offerId}/counter`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify(offer),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const uploadValidationDocument = (user, payload, type) =>
  oauth2
    .fetch(`${api}/client/${type}/document`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAttachedDocuement = (user, id, type) =>
  oauth2
    .fetch(`${api}/client/${type}/document/file?document_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getDownloadPaymentDocument = (user, id, type) =>
  oauth2
    .fetch(`${api}/client/${type}/document?document_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAttachedDocuementForConsumer = (user, id, type) =>
  oauth2
    .fetch(`${api}/consumer/${type}/document/file?document_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const updateValidationDocument = (user, payload, type) =>
  oauth2
    .fetch(`${api}/client/${type}/document`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const deleteVerificationDocument = (user, doc_id, type) =>
  oauth2
    .fetch(`${api}/client/${type}/document?document_id=${doc_id}`, {
      method: "DELETE",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getInvoiceDocuments = (user, id) =>
  oauth2
    .fetch(`${api}/client/debts/document?invoice_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getMultiInvoiceDocuments = (user, payload) =>
  oauth2
    .fetch(`${api}/client/debts/multidoclist`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getDebtValidationDocuments = (user, id) =>
  oauth2
    .fetch(`${api}/client/debts/document?debt_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getConsumerDebtPaymentHistory = (user, id) =>
  oauth2
    .fetch(`${api}/consumer/paymentHistory?debt_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const requestValidationDocumentsMailed = (user, id) =>
  oauth2
    .fetch(`${api}/consumer/debts/${id}/request_documentation`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

//------------1023 start ---------------------
export const updateConsumerProfile = (user, id) =>
  oauth2
    .fetch(`${api}/consumer/profile`, {
      method: "POST",
      headers: setHeaders(user, true, false),
      body: JSON.stringify(user),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error(error);
    });
//------------1023 end -----------------------

// ---- CONSUMER::HELP FORM ----
export const consumerRequestHelp = (user, formData) =>
  oauth2
    .fetch(`${api}/contact_us`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify(formData),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const consumerGetHelp = (key, formData) =>
  oauth2
    .fetch(`${api}/contact_us`, {
      method: "POST",
      headers: setHeaders({ organization_key: key }, false, true),
      body: JSON.stringify(formData),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const marketingContact = (formData) =>
  oauth2
    .fetch(`${api}/contact_us`, {
      method: "POST",
      headers: setHeaders(null, false, true),
      body: JSON.stringify(formData),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// ----------------------------------------------------------------------------- //

//---- CLIENTS::SEARCH ----

export const clientsSearch = (user, context, query) =>
  oauth2
    .fetch(`${api}/client/search/${context}?q=${query}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientsOfferSearch = (user, role, context, offer_type, query) =>
  oauth2
    .fetch(`${api}/${role}/search/${context}?type=${offer_type}&q=${query}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// ---- CLIENTS::ADMIN ----
export const fetchAllClients = (user) =>
  oauth2
    .fetch(`${api}/client/admins`, { headers: setHeaders(user, true, false) })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const createClients = (user, clientsCanidate) =>
  oauth2
    .fetch(`${api}/client/admins/`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        user: {
          ...clientsCanidate,
        },
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const deactivateClients = (user, clientsId) =>
  oauth2
    .fetch(`${api}/client/admins/${clientsId}/deactivate`, {
      method: "POST",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const createClientAdmin = (user, adminCanidate) =>
  oauth2
    .fetch(`${api}/client/createClientAdmin/`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        user: {
          ...adminCanidate,
        },
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const createEmployee = (
  user,
  adminCandidate,
  consumer_ids,
  is_all_client,
  save_and_send
) =>
  oauth2
    .fetch(`${api}/client/employee/create`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        user: {
          ...adminCandidate,
        },
        consumer_ids,
        is_all_client,
        save_and_send,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const updateEmployee = (
  user,
  adminCandidate,
  consumer_ids,
  is_all_client,
  save_and_send
) =>
  oauth2
    .fetch(`${api}/client/employee/update`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        user: {
          ...adminCandidate,
        },
        consumer_ids,
        is_all_client,
        save_and_send,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchEmployeeDetails = (user, id) =>
  oauth2
    .fetch(`${api}/users/details?user_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSentMails = (user, page, user_id, status) => {
  const params = new URLSearchParams();
  params.append("page", String(page ?? 0));
  params.append("all", "true");

  if (Array.isArray(user_id) && user_id.length > 0) {
    params.append("user_id", String(user_id[0]));
  } else if (user_id != null && user_id !== "") {
    params.append("user_id", String(user_id));
  }

  const appendStatusArray = (values) => {
    values.forEach((v) => {
      const s =
        typeof v === "object" && v?.value != null
          ? String(v.value).trim()
          : String(v).trim();
      if (s) params.append("status[]", s);
    });
  };
  if (Array.isArray(status) && status.length > 0) {
    appendStatusArray(status);
  } else if (status != null && String(status).trim() !== "") {
    appendStatusArray(String(status).split(","));
  }

  const qs = params.toString();
  return oauth2
    .fetch(`${api}/client/mandrill/getSentMailList?${qs}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getSubAccountDetails = (user) =>
  oauth2
    .fetch(`${api}/client/mandrill/getSubaccountDetail`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
// ---- CLIENTS::CONSUMERS ----

export const fetchAllClientsConsumers = (user) =>
  oauth2
    .fetch(`${api}/admin/client/consumers`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchAllCompanyClients = (user, offset) =>
  oauth2
    .fetch(`${api}/client/consumers?offset=${offset}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getTeamMembers = (user, isAccount) => {
  return oauth2
    .fetch(`${api}/client/employee/list?page=0&is_account=${isAccount}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getRecurringInvoiceNumber = (user) => {
  return oauth2
    .fetch(
      `${api}/client/recurring_invoice_schedules/generate_invoice_number`,
      {
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const addRecurringInvoice = (user, payload) => {
  return oauth2
    .fetch(`${api}/client/recurring_invoice_schedules`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const fetchAllEmployees = (user, offset, searchText) =>
  searchText == null || searchText == ""
    ? oauth2
        .fetch(`${api}/client/employee/list?offset=${offset}`, {
          headers: setHeaders(user, true, false),
        })
        .then((response) => response.json())
        .then(function (data) {
          return data;
        })
        .catch((error) => {
          console.error("error==========:", error);
        })
    : oauth2
        .fetch(`${api}/client/employee/list?offset=${offset}&q=${searchText}`, {
          headers: setHeaders(user, true, false),
        })
        .then((response) => response.json())
        .then(function (data) {
          return data;
        })
        .catch((error) => {
          console.error("error==========:", error);
        });

export const fetchAllClientsPendingAddressConsumers = (user) =>
  oauth2
    .fetch(`${api}/client/consumers/pendingAddressUser`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getClientsConsumer = (
  user,
  id,
  order,
  offset,
  filter_by,
  sort_by = "",
  order_by = "",
  filters = {}
) => {
  const params = new URLSearchParams();
  params.append("page", String(offset ?? 0));
  params.append("filter_by", filter_by ?? "all");
  if (sort_by && order_by) {
    params.append("sort_by", sort_by);
    params.append("order_by", order_by);
  } else if (order) {
    params.append("order", order);
  }
  const filterPairs = [
    ["from_date", filters?.from_date],
    ["to_date", filters?.to_date],
    ["due_from_date", filters?.due_from_date],
    ["due_to_date", filters?.due_to_date],
    ["min_balance", filters?.min_balance],
    ["max_balance", filters?.max_balance],
    ["invoice_number", filters?.invoice_number],
  ];
  filterPairs.forEach(([key, val]) => {
    if (val != null && String(val).trim() !== "") {
      params.append(key, String(val).trim());
    }
  });
  return oauth2
    .fetch(`${api}/client/consumers/${id}?${params.toString()}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getViewClientsConsumerConversation = (user, id) =>
  oauth2
    .fetch(`${api}/client/consumers/${id}/conversation`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getMailHistoryEngagementDetails = (
  user,
  consumer_id,
  mail_history_id
) =>
  oauth2
    .fetch(
      `${api}/client/consumers/${consumer_id}/mail_histories/${mail_history_id}/engagement_details`,
      {
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getClientsConsumerEdit = (user, consumer_id) =>
  oauth2
    .fetch(`${api}/client/consumers/${consumer_id}/edit`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateClientsConsumer = (user, consumer_id, consumer) =>
  oauth2
    .fetch(`${api}/client/consumers/${consumer_id}`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        consumer,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const addConsumerDebt = (user, consumer_id, consumer) =>
  oauth2
    .fetch(`${api}/client/debts/create/`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        consumer,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const createClientsConsumer = (user, consumer) =>
  oauth2
    .fetch(`${api}/client/consumers`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        consumer,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const deactivateClientsConsumer = (user, consumer_id) =>
  oauth2
    .fetch(`${api}/client/consumers/${consumer_id}/deactivate`, {
      method: "POST",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const deleteClientsConsumer = (user, consumer_ids) =>
  oauth2
    .fetch(`${api}/client/delete?ids=${[consumer_ids]}`, {
      method: "DELETE",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// ---- CLIENTS::OFFERS ----

export const getClientsOfferList = (user, context, offer_type) =>
  oauth2
    .fetch(`${api}/${context}/offers/getOfferList?offer_type=` + offer_type, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getPendingClientsOffersCount = (user) =>
  oauth2
    .fetch(`${api}/client/offers/pendingOffersCount`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientsAcceptOffer = (user, context, offerId, note) =>
  oauth2
    .fetch(`${api}/${context}/offers/${offerId}/accept`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ description: note }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientsCounterOffer = (user, context, offerId, offer) =>
  oauth2
    .fetch(`${api}/${context}/offers/${offerId}/counter`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify(offer),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientsRejectOffer = (user, context, offerId, note) =>
  oauth2
    .fetch(`${api}/${context}/offers/${offerId}/reject`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ description: note }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const companyAdminSearch = (user, context, query) =>
  oauth2
    .fetch(`${api}/admin/client/search/${context}?q=${query}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const companySearch = (user, context, query) =>
  oauth2
    .fetch(`${api}/client/search/${context}?q=${query}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const createOrganization = (user, organization) =>
  oauth2
    .fetch(`${api}/admin/organizations/`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        organization,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// ---- CLIENT::SEARCH ----

export const clientSearch = (
  user,
  context,
  query,
  offset,
  lobSearch,
  customer_type,
  sort_by,
  order
) => {
  let url = `${api}/client/search/${context}?q=${encodeURIComponent(
    query ?? ""
  )}`;
  if (lobSearch) {
    url += `&lobSearch=${encodeURIComponent(lobSearch)}`;
  }
  url += `&customer_type=${encodeURIComponent(customer_type ?? "")}`;
  url += `&offset=${encodeURIComponent(offset ?? "")}`;
  if (sort_by) {
    url += `&sort_by=${encodeURIComponent(sort_by)}`;
  }
  if (order) {
    url += `&order=${encodeURIComponent(order)}`;
  }
  return oauth2
    .fetch(url, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

// ---- CONSUMER::SEARCH ----

export const consumerSearch = (user, text, id, is_open) =>
  oauth2
    .fetch(
      `${api}/consumer/invoice/search?text=${text}&user_id=${id}&is_open=${is_open}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientOfferSearch = (user, context, offer_type, query) =>
  oauth2
    .fetch(`${api}/client/search/${context}?type=${offer_type}&q=${query}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const uploadClientCSV = (user, csv) =>
  oauth2
    .fetch(`${api}/client/debts/import`, {
      method: "POST",
      headers: setHeaders(user, true, false),
      body: csv,
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const paymentByChequeOrCash = (user, paymentInfo) =>
  oauth2
    .fetch(`${api}/client/payment`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        paymentInfo,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const receivePaymentByChequeOrCash = (user, paymentInfo, id) =>
  oauth2
    .fetch(`${api}/client/payment_plans/${id}/receive_payment`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        paymentInfo,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const receiveMultipleInvoicesPayment = (user, paymentInfo, id) =>
  oauth2
    .fetch(`${api}/client/multiple_invoices_payment`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        paymentInfo,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const acceptClientsConsumerOffer = (user, consumer_ids) =>
  oauth2
    .fetch(`${api}/client/accept_multiple_offers`, {
      method: "POST",
      headers: setHeaders(user, true, false),
      body: JSON.stringify({
        consumer_ids,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const rejectClientsConsumerOffer = (user, consumer_ids) =>
  oauth2
    .fetch(`${api}/client/reject_multiple_offers`, {
      method: "POST",
      headers: setHeaders(user, true, false),
      body: JSON.stringify({
        consumer_ids,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const updateDefaultService = (user, payload) => {
  return oauth2
    .fetch(`${api}/client/default_service`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });
};
export const updateClient = (client, clientUpdate, user_id) =>
  oauth2
    .fetch(`${api}/client/update_user/${user_id}`, {
      method: "PUT",
      headers: setHeaders(client, true, true),
      body: JSON.stringify({
        client: {
          ...clientUpdate,
        },
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientUpdateEmployee = (client, empId, clientUpdateEmployee) =>
  oauth2
    .fetch(`${api}/client/employee/update?id=${empId}`, {
      method: "POST",
      headers: setHeaders(client, true, true),
      body: JSON.stringify({
        employee: {
          ...clientUpdateEmployee,
        },
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const skipPaymetSetting = (client, skip_payment_value) =>
  oauth2
    .fetch(`${api}/client/skipOfferPayment`, {
      method: "POST",
      headers: setHeaders(client, true, true),
      body: JSON.stringify({
        ...skip_payment_value,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const skipPaymetForConsumer = (user, info) =>
  oauth2
    .fetch(`${api}/consumer/skip_payment`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ info }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const saveNegotiationThreshold = (client, negotiationData) =>
  oauth2
    .fetch(`${api}/client/threshold/create_multiple`, {
      method: "POST",
      headers: setHeaders(client, true, true),
      body: JSON.stringify({
        ...negotiationData,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchSkipPaymentData = (user) =>
  oauth2
    .fetch(`${api}/client/get_skip_payment`, {
      headers: setHeaders(user, true, true),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchPaymentHistory = (
  user,
  context,
  paymentType,
  offset,
  searchText,
  sort_key,
  sort_by,
  payment,
  status,
  user_id,
  from_date,
  to_date,
  min_amount,
  max_amount
) => {
  const params = new URLSearchParams();

  // Add parameters only if they have values
  if (paymentType) params.append("type", paymentType);
  if (offset !== undefined && offset !== null) params.append("offset", offset);
  if (sort_by) params.append("order", sort_by);
  if (sort_key) params.append("sort_by", sort_key);
  if (searchText) params.append("searchText", searchText);
  if (user_id) params.append("user_id", user_id);
  if (from_date) params.append("from_date", from_date);
  if (to_date) params.append("to_date", to_date);
  if (payment) params.append("payment_method", payment);
  if (status) params.append("status", status);
  if (min_amount !== undefined && min_amount !== null)
    params.append("min_amount", min_amount);
  if (max_amount !== undefined && max_amount !== null)
    params.append("max_amount", max_amount);

  const url = `${api}/${context}/paymentHistory?${params.toString()}`;

  return oauth2
    .fetch(url, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const fetchLobHistory = (user, offset, searchText, query) =>
  oauth2
    .fetch(
      `${api}/client/lob/list?offset=${offset}&searchText=${searchText}&${query}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchNotificationHistory = (
  user,
  page,
  filter_by,
  filters = {}
) => {
  const params = new URLSearchParams({ page: String(page) });

  if (filter_by) params.append("filter_by", filter_by);
  if (filters.account_name)
    params.append("account_name", String(filters.account_name));
  if (filters.mg_entity_number)
    params.append("mg_entity_number", String(filters.mg_entity_number));
  if (filters.entity_type) params.append("entity_type", filters.entity_type);
  if (filters.created_at_from)
    params.append("created_at_from", filters.created_at_from);
  if (filters.created_at_to)
    params.append("created_at_to", filters.created_at_to);
  if (filters.updated_at_from)
    params.append("updated_at_from", filters.updated_at_from);
  if (filters.updated_at_to)
    params.append("updated_at_to", filters.updated_at_to);
  if (typeof filters.is_addressed === "boolean")
    params.append("is_addressed", String(filters.is_addressed));

  return oauth2
    .fetch(`${api}/client/notifications?${params.toString()}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const fetchSmsHistory = (user, page = 0, filters = {}) => {
  const params = new URLSearchParams({ page: String(page) });

  if (filters.deposit_id != null)
    params.append("deposit_id", String(filters.deposit_id));
  if (
    filters.template_key != null &&
    (typeof filters.template_key !== "string" ||
      filters.template_key.trim() !== "")
  ) {
    params.append(
      "template_key",
      typeof filters.template_key === "string"
        ? filters.template_key.trim()
        : String(filters.template_key)
    );
  }

  const appendStatusArray = (values) => {
    values.forEach((v) => {
      const s =
        typeof v === "object" && v?.value != null
          ? String(v.value).trim()
          : String(v).trim();
      if (s) params.append("status[]", s);
    });
  };
  if (Array.isArray(filters.status) && filters.status.length > 0) {
    appendStatusArray(filters.status);
  } else if (filters.status != null && String(filters.status).trim() !== "") {
    appendStatusArray(String(filters.status).split(","));
  }

  return oauth2
    .fetch(`${api}/client/sms/list?${params.toString()}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const fetchNotificationFilterOptions = (user) =>
  oauth2
    .fetch(`${api}/client/notifications/filter_options`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateNotificationHistory = (user, id) =>
  oauth2
    .fetch(`${api}/client/notifications/${id}`, {
      method: "PUT",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendMailByLob = (user, mailData) =>
  oauth2
    .fetch(`${api}/client/lob/sendLetter`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...mailData,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchChatHistory = (user, offset) =>
  oauth2
    .fetch(`${api}/client/intercom/conversation?offset=${offset}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchConsumerChatHistory = (user, userId) =>
  oauth2
    .fetch(`${api}/client/intercom/user/conversation?user_id=${userId}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchMailchimpCampaignHistory = (user, offset) =>
  oauth2
    .fetch(`${api}/client/mailchimps/getAllCampaignList?offset=${offset}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchMailchimpCampaignMemberHistory = (
  user,
  workflow_id,
  offset
) =>
  oauth2
    .fetch(
      `${api}/client/mailchimps/getAllCampaignMembers?workflow_id=${workflow_id}&?offset=${offset}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchSkipTraceData = (user, offset) =>
  oauth2
    .fetch(`${api}/client/skip_traces/getSkipTraceList?offset=${offset}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const uploadSkipTraceCSV = (user, csv) =>
  oauth2
    .fetch(`${api}/client/skip_traces/import`, {
      method: "POST",
      headers: setHeaders(user, true, false),
      body: csv,
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientSkipTraceUserSearch = (user, query) =>
  oauth2
    .fetch(`${api}/client/skip_traces/search?q=${query}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const adjustmentPayment = (user, paymentInfo) =>
  oauth2
    .fetch(`${api}/client/adjustmentPayment`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        paymentInfo,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getLobTemplate = (user, type) => {
  return oauth2
    .fetch(`${api}/client/lob/templateListFromDb?type=${type}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

// /client/invoice/pause_comms?invoice_id=18335
export const pauseInvoiceComms = (user, invoiceId) =>
  oauth2
    .fetch(`${api}/client/invoice/pause_comms?invoice_id=${invoiceId}`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getMergeVariablesForLobTemplate = (user, id, params = {}) => {
  const queryParams = {};
  if (id !== undefined && id !== null && id !== "") {
    queryParams.id = id;
  }
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      if (typeof value === "object") {
        queryParams[key] = Array.isArray(value)
          ? JSON.stringify(value)
          : JSON.stringify(value);
      } else {
        queryParams[key] = value;
      }
    }
  });
  const query = new URLSearchParams(queryParams).toString();

  return oauth2
    .fetch(`${api}/client/lob/template_vars?${query}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getMandrillTemplate = (user, tempSlug, type) =>
  oauth2
    .fetch(
      `${api}/client/mandrill/getTemplateList?template=${tempSlug}&type=${type}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const getPaymentPlansTemplate = (user) =>
  oauth2
    .fetch(`${api}/client/payment_plans/templates`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getMergeVariables = (user, name) =>
  oauth2
    .fetch(`${api}/client//mandrill/getMergeVariable?name=${name}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendMandrillTemplate = (user, payload, userId) =>
  oauth2
    .fetch(`${api}/client/mandrill/sendMailManually?user_id=${userId}`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });
export const freeFormEmail = (user, payload) =>
  oauth2
    .fetch(`${api}/client/invoice/freeFormEmail`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendMultipleMandrillTemplate = (user, payload, userId) =>
  oauth2
    .fetch(`${api}/client/mandrill/sendMultipleInvoices?user_id=${userId}`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendPaymentPlanEmail = (user, payload) =>
  oauth2
    .fetch(`${api}/client/payment_plans/send_mail`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const registrationCodeVerification = (token) =>
  oauth2
    .fetch(`${api}/client/consumer/validate`, {
      method: "POST",
      headers: setHeaders(null, false, true),
      body: JSON.stringify({
        token: token,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateNewRegisterUser = (userUpdate) =>
  oauth2
    .fetch(`${api}/users/update_consumer`, {
      method: "PUT",
      headers: setHeaders(null, false, true),
      body: JSON.stringify(userUpdate),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendOTP = (data) => {
  const theme = JSON.parse(localStorage.getItem("themeData"));
  const orgKey = theme.organization_key;
  return oauth2
    .fetch(`${api}/users/send_registration_otp_code?org_key=${orgKey}`, {
      method: "PUT",
      headers: setHeaders(null, false, true),
      body: JSON.stringify(data),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const verifyOTP = (data) => {
  const theme = JSON.parse(localStorage.getItem("themeData"));
  const orgKey = theme.organization_key;
  return oauth2
    .fetch(`${api}/users/veriy_otp?org_key=${orgKey}`, {
      method: "PUT",
      headers: setHeaders(null, false, true),
      body: JSON.stringify(data),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const updateUserPassword = (data) =>
  oauth2
    .fetch(`${api}/users/update_user_password`, {
      method: "PUT",
      headers: setHeaders(null, false, true),
      body: JSON.stringify(data),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const startAutomatedMails = (user, query) =>
  oauth2
    .fetch(`${api}/client/consumer/startAutomatedMails?user_id=${query}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const addOrganization = (user, organization) =>
  oauth2
    .fetch(`${api}/admin/organization/create`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify(organization),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchAllOrganizations = (user, page, searchText) =>
  oauth2
    .fetch(
      `${api}/admin/organization/list?page=${page}&search_text=${searchText}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchOrganizationDetails = (user, id) =>
  oauth2
    .fetch(`${api}/admin/organization/detail?id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateOrganization = (user, payload) =>
  oauth2
    .fetch(`${api}/admin/organization/updateOrg`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateInternalContact = (user, payload) =>
  oauth2
    .fetch(`${api}/client/employee/update_internal_contact`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const updateGoodQuantityPermission = (user, payload) =>
  oauth2
    .fetch(`${api}/client/employee/update_permission`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateClientPassword = (user, password) =>
  oauth2
    .fetch(`${api}/client/updatePassword`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        password: password,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

//employee
export const updateEmployeePassword = (user, password) =>
  oauth2
    .fetch(`${api}/employee/updatePassword`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        password: password,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchAllClientsEmployee = (user) =>
  oauth2
    .fetch(`${api}/client/employee/listAll`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchAllUnassignedConsumers = (user, employee_id) =>
  oauth2
    .fetch(`${api}/client/consumer/unassigned?employee_id=${employee_id}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const assignEmployeeToConsumer = (user, payload) =>
  oauth2
    .fetch(`${api}/client/employee/assignToConsumers`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        employee_id: payload.employee_id,
        user_ids: payload.user_ids,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchAllConsumerForEmployee = (user, offset) =>
  oauth2
    .fetch(`${api}/employee/accounts?offset=${offset}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const employeeCreateConsumer = (user, consumer) =>
  oauth2
    .fetch(`${api}/employee/consumers`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        consumer,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const employeeSearchConsumers = (user, query, offset, lobSearch) =>
  oauth2
    .fetch(
      `${api}/employee/searchConsumers?q=${query}&lobSearch=${
        lobSearch ? lobSearch : false
      }`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const validateQB = (user) =>
  oauth2
    .fetch(`${api}/qb`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const checkAuthStatus = (user, cancel_sync = false) =>
  oauth2
    .fetch(`${api}/qb/checkAuthStatus?cancel_sync=${cancel_sync}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getQBCustomer = (user) =>
  oauth2
    .fetch(`${api}/qb/customer`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateQbSettings = (user, settings) =>
  oauth2
    .fetch(`${api}/qb/update_qb_setting`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...settings,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getQbSetting = (user) =>
  oauth2
    .fetch(`${api}/qb/qb_setting`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getQbItemCount = (user) =>
  oauth2
    .fetch(`${api}/qb/items_to_sync_count`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getTasksList = (user) =>
  oauth2
    .fetch(`${api}/client/setting_tasks/getList`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getPaymentPlPlanTaskList = (user) =>
  oauth2
    .fetch(`${api}/client/payment_plan_task_config/list`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateTaskSetting = (user, settings) =>
  oauth2
    .fetch(`${api}/client/setting_tasks/updateSetting`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...settings,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const paymentPlanTaskUpdate = (user, settings) =>
  oauth2
    .fetch(`${api}/client/payment_plan_task_config/update`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...settings,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSelectedContacts = (user, id) =>
  oauth2
    .fetch(`${api}/client/setting_tasks/getSelectedContacts?task_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const getSelectedContactsunassigned = (user, id, offset) =>
  oauth2
    .fetch(`${api}/client/consumer/unassigned`, {
      method: "GET",
      headers: setHeaders(user.user_id, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSettingsTasks = (user) =>
  oauth2
    .fetch(`${api}/client/setting_tasks/getTasks`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getInvoiceTasks = (
  user,
  id,
  page,
  sortBy,
  orderBy,
  user_id,
  filterBy = ""
) =>
  oauth2
    .fetch(
      `${api}/client/setting_tasks/getInvoiceTasks?task_id=${id}&page=${page}&sort_by=${sortBy}&order_by=${orderBy}&user_id=${user_id}${filterBy ? filterBy : ""}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const dashobardArReport = (user, sort_by, sort_key, page) => {
  return oauth2
    .fetch(
      `${api}/dashboard/arAgingReport?sort_by=${sort_by}&order=${sort_key}&page=${page}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

// export const searchByEverything = (user, searchTerm) => {
//   return oauth2
//     .fetch(`${api}/client/search/all?q=${searchTerm}`, {
//       method: "GET",
//       headers: setHeaders(user, true, false),
//     })
//     .then((response) => response.json())
//     .then(function (data) {
//       return data;
//     })
//     .catch((error) => {
//       console.error("error==========:", error);
//     });
// };

export const dashboardUpcomingEvents = (user) =>
  oauth2
    .fetch(`${api}/dashboard/upcoming_events`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const ArAgingReport = (user) =>
  oauth2
    .fetch(`${api}/dashboard/arAgingReport`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAcpAddCeiReport = (user) =>
  oauth2
    .fetch(`${api}/dashboard/getAcpAddCeiReport`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getMostAtRiskReport = (user) =>
  oauth2
    .fetch(`${api}/dashboard/getMostAtRiskReport`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSubscriptionReport = (user, key) =>
  oauth2
    .fetch(
      `${api}/client/reports/subscription_report_list?search_text=${key}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// Only the Communication Report sends a type; other reports keep their existing URLs.
const getFilterByParam = (filter_by) =>
  filter_by ? `&filter_by[]=${encodeURIComponent(filter_by)}` : "";

// item_names for only inventory consumption reports
export const arAgingSummaryList = (
  user,
  id,
  from,
  to,
  item_ids,
  date_type,
  page = 0,
  filter_by = "",
  comm_page = null
) =>
  oauth2
    .fetch(
      `${api}/client/reports/ar_aging_summary_list_for_api?master_report_id=${id}&from_date=${from}&to_date=${to}&item_ids=${item_ids}&date_type=${date_type}&page=${page}${getFilterByParam(
        filter_by
      )}${comm_page === null ? "" : `&comm_page=${comm_page}`}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchAllClientsForTask = () =>
  oauth2
    .fetch(`${api}/client/fetchAllClientsForTask`, {
      method: "GET",
      headers: setHeaders(null, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// item_names params is used for inventory consumption report
export const downloadReport = (
  user,
  reportId,
  type,
  from,
  to,
  item_ids,
  date_type,
  filter_by = ""
) =>
  oauth2
    .fetch(
      `${api}/client/reports/download_report?master_report_id=${reportId}&report_format=${type}&from_date=${from}&to_date=${to}&item_ids=${item_ids}&date_type=${date_type}${getFilterByParam(
        filter_by
      )}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAccountActivities = (
  user,
  id,
  page = 0,
  filter = "",
  invoiceIds = []
) => {
  const invoiceIdsQuery =
    Array.isArray(invoiceIds) && invoiceIds.length
      ? invoiceIds
          .map((invoiceId) => `&invoice_ids[]=${encodeURIComponent(invoiceId)}`)
          .join("")
      : "";

  return oauth2
    .fetch(
      `${api}/client/consumer/activities?user_id=${id}&page=${page}&filter=${filter}${invoiceIdsQuery}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const searchInvoiceId = (user, id) =>
  oauth2
    .fetch(`${api}/client/invoice/search?text=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const searchInvoiceForConsumer = (user, id, sub_account_id) =>
  oauth2
    .fetch(
      `${api}/consumer/search_invoice?text=${id}&sub_account_id=${sub_account_id}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getInvoiceList = (user, due_date, order, offset, filter_by) =>
  oauth2
    .fetch(
      `${api}/client/invoice/list?sort_by=${due_date}&order=${order}&page=${offset}&filter_by=${filter_by}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getInvoiceDetails = (user, id) =>
  oauth2
    .fetch(`${api}/client/invoice/detail?id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getRecurringInvoiceDetails = (user, id) =>
  oauth2
    .fetch(`${api}/client/recurring_invoice_schedules/${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSubscriptionList = (user, id) =>
  oauth2
    .fetch(`${api}/client/subscriptions/get_subscription_list`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const createSubscription = (user, payload) =>
  oauth2
    .fetch(`${api}/client/subscriptions/create_new_subscription`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateSubscription = (user, payload) =>
  oauth2
    .fetch(`${api}/client/subscriptions/update_subscription`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const addInvoiceNote = (user, payload) =>
  oauth2
    .fetch(`${api}/client/invoice_notes`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const addAccountNote = (user, payload, accountId) => {
  return oauth2
    .fetch(`${api}/client/consumers/${accountId}/add_note`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getAccountCommunication = (
  user,
  accountId,
  type,
  page = 0,
  invoiceIds = [],
  sort_by = "",
  sort_order = "",
  filters = {}
) => {
  const invoiceIdsQuery =
    Array.isArray(invoiceIds) && invoiceIds.length
      ? invoiceIds
          .map((invoiceId) => `&invoice_ids[]=${encodeURIComponent(invoiceId)}`)
          .join("")
      : "";
  const sortQuery =
    sort_by && sort_order
      ? `&sort_by=${encodeURIComponent(sort_by)}&order_by=${encodeURIComponent(sort_order)}`
      : "";
  const filterPairs = [
    ["name", filters?.name],
    ["invoice_number", filters?.invoice_number],
    ["from_date", filters?.from_date],
    ["to_date", filters?.to_date],
    ["filter_by", filters?.filter_by],
    ["status", filters?.status],
    ["template_name", filters?.template_name ?? filters?.slug],
    ["receiver_email", filters?.receiver_email],
    ["expected_delivery_from_date", filters?.expected_delivery_from_date],
    ["expected_delivery_to_date", filters?.expected_delivery_to_date],
    ["customer_name", filters?.customer_name],
  ];
  const filtersQuery = filterPairs
    .filter(([, val]) => val != null && String(val).trim() !== "")
    .map(
      ([key, val]) =>
        `&${encodeURIComponent(key)}=${encodeURIComponent(String(val).trim())}`
    )
    .join("");
  return oauth2
    .fetch(
      `${api}/client/consumers/${accountId}/communications?type=${type}&page=${page}${invoiceIdsQuery}${sortQuery}${filtersQuery}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getCommunicationNameList = (user, accountId, type) => {
  const params = new URLSearchParams();
  if (type && type !== "All") {
    params.set("type", type);
  }
  const query = params.toString();
  return oauth2
    .fetch(
      `${api}/client/consumers/${accountId}/communications/name_list${query ? `?${query}` : ""}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const toggleCommunicationPin = (user, accountId, data) => {
  return oauth2
    .fetch(`${api}/client/consumers/${accountId}/communications/pin`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify(data),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getAccountLevelEmailTemplates = (user) => {
  return oauth2
    .fetch(`${api}/client/mandrill/getTemplateList?template=&type=Account`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};
export const deleteSubscription = (user, payload) =>
  oauth2
    .fetch(`${api}/client/subscriptions/delete_subscription`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getInvoiceHistory = (user, id) =>
  oauth2
    .fetch(`${api}/client/invoice/history?id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const reImportInvoice = (user, id) =>
  oauth2
    .fetch(`${api}/qb/invoice?id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendInvoice = (user, id) =>
  oauth2
    .fetch(`${api}/client/mandrill/send_invoice?invoice_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getRefundList = (user, id) =>
  oauth2
    .fetch(`${api}/client/refund/payments?invoice_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getUnappliedPayments = (
  user,
  id,
  offset,
  status,
  fromDate,
  toDate,
  sort_by = "",
  order_by = "",
  payment_method = "",
  customer_name = ""
) => {
  const params = new URLSearchParams();
  params.append("offset", String(offset ?? 0));
  const appendStatusArray = (values) => {
    values.forEach((v) => {
      const s = String(v).trim();
      if (s) params.append("status[]", s);
    });
  };
  if (Array.isArray(status) && status.length > 0) {
    appendStatusArray(status);
  } else if (status != null && String(status).trim() !== "") {
    appendStatusArray(String(status).split(","));
  }
  if (fromDate != null && String(fromDate).trim() !== "") {
    params.append("from_date", String(fromDate).trim());
  }
  if (toDate != null && String(toDate).trim() !== "") {
    params.append("to_date", String(toDate).trim());
  }
  if (sort_by && order_by) {
    params.append("sort_by", sort_by);
    params.append("order_by", order_by);
  }
  if (payment_method != null && String(payment_method).trim() !== "") {
    params.append("payment_method", String(payment_method).trim());
  }
  if (customer_name != null && String(customer_name).trim() !== "") {
    params.append("customer_name", String(customer_name).trim());
  }

  const qs = params.toString();
  const url = `${api}/client/consumers/${id}/payments${qs ? `?${qs}` : ""}`;

  return oauth2
    .fetch(url, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getUnappliedPaymentList = (user, id, offset) => {
  return oauth2
    .fetch(`${api}/client/consumers/${id}/payments?filter_by=unapplied`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

//cancel refund payment
export const getCancelRefundList = (user, id) =>
  oauth2
    .fetch(`${api}/client/payment/payments_to_cancel?invoice_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const cancelRefundPayment = (user, payload) =>
  oauth2
    .fetch(`${api}/client/payment/cancel`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

//consumer invoice
export const fetchAllConsumerInvoices = (
  user,
  page,
  is_open,
  sub_accounts_id
) =>
  oauth2
    .fetch(
      `${api}/consumer/invoice/pageData?sub_account_id=${sub_accounts_id}&page=${page}&is_open=${is_open}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const consumerInvoicesPagination = (
  user,
  page,
  is_open,
  filter_by,
  sub_account_id
) =>
  oauth2
    .fetch(
      `${api}/consumer/invoice/list?sub_account_id=${sub_account_id}&page=${page}&is_open=${is_open}&filter_by=${filter_by}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const fetchConsumerInvoiceDetails = (user, id) =>
  oauth2
    .fetch(`${api}/consumer/invoice/detail?id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getConsumerDetails = (user, sub_account_id) =>
  oauth2
    .fetch(`${api}/consumer/profileData?sub_account_id=${sub_account_id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updatePersonalInfo = (user, payload, sub_account_id) =>
  oauth2
    .fetch(
      `${api}/consumer/updatePersonalInfo?sub_account_id=${sub_account_id}`,
      {
        method: "PUT",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({
          ...payload,
        }),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateCompanyInfo = (user, payload, sub_account_id) =>
  oauth2
    .fetch(
      `${api}/consumer/updateCompanyInfo?sub_account_id=${sub_account_id}`,
      {
        method: "PUT",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({
          ...payload,
        }),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const disconnectQB = (user) =>
  oauth2
    .fetch(`${api}/qb/disconnectAccount`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getInvoiceForExpressPayment = (key, number, amount) =>
  oauth2
    .fetch(
      `${api}/expressPayment/getInvoice?invoice_number=${number}&invoice_amount=${amount}&within_invoice_detail=true`,
      {
        method: "GET",
        headers: setHeaders({ organization_key: key }, true, true),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendPaymentReceipt = (invoice_number, amount, email) =>
  oauth2
    .fetch(
      `${api}/expressPayment/send_payment_receipt?invoice_number=${invoice_number}&amount=${amount}&email=${email}`,
      {
        method: "GET",
        headers: setHeaders(null, false, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendRegistrationLink = (user, userId) =>
  oauth2
    .fetch(`${api}/users/send_registration_link?user_id=${userId}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateConsumerBillingDetails = (user, consumer) =>
  oauth2
    .fetch(`${api}/client/consumer/update_billing_details`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...consumer,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const consumerMakePayment = (user, payload, sub_account_id) => {
  return oauth2
    .fetch(`${api}/consumer/make_payment?sub_account_id=${sub_account_id}`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const consumerMakePaymentForPlans = (user, payload, sub_account_id) =>
  oauth2
    .fetch(
      `${api}/consumer/payment_plan/receive_payment?sub_account_id=${sub_account_id}`,
      {
        method: "PUT",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({
          ...payload,
        }),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

//pay Invoices
export const payMultipleInvoices = (user, payload, sub_account_id) => {
  return oauth2
    .fetch(
      `${api}/consumer/make_payment_for_invoices?sub_account_id=${sub_account_id}`,
      {
        method: "POST",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({
          ...payload,
        }),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const updateSubscriptionStatus = (user, data) =>
  oauth2
    .fetch(`${api}/client/subscriptions/update_status`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...data,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAdminProfilePopupData = (user) =>
  oauth2
    .fetch(`${api}/admin/profile/popupData`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const adminCreateProfile = (user, payload) =>
  oauth2
    .fetch(`${api}/admin/profile/create`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const adminUpdateProfile = (user, payload) =>
  oauth2
    .fetch(`${api}/admin/profile/update`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAdminProfileList = (user, offset) =>
  oauth2
    .fetch(`${api}/admin/profile/list?offset=${offset}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const deleteAdminProfile = (user, id) =>
  oauth2
    .fetch(`${api}/admin//profile/delete?id=${id}`, {
      method: "DELETE",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getOrganizationTaskList = (user, id) =>
  oauth2
    .fetch(`${api}/admin/task/list?organization_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getTemplateMergeVar = (user, id, slugName) =>
  oauth2
    .fetch(
      `${api}/admin/task/templateMergeVariables?organization_id=${id}&name=${slugName}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getTemplateMergeVarForClients = (user, slugName) =>
  oauth2
    .fetch(`${api}/client/task/templateMergeVariables?name=${slugName}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const previewTaskTemplate = (user, payload) =>
  oauth2
    .fetch(`${api}/admin/task/previewTemplate`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getOrganizationTaskProfileTemp = (user, id) =>
  oauth2
    .fetch(`${api}/admin/task/profileTemplates?organization_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const orgTemplatesAssigned = (user, id) =>
  oauth2
    .fetch(
      `${api}/admin/organization/templatesAssigned?organization_id=${id}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const adminAssignTaskTemplates = (user, payload) =>
  oauth2
    .fetch(`${api}/admin/task/assignTemplates`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateAssignTemplates = (user, payload) =>
  oauth2
    .fetch(`${api}/admin/organization/AssignTemplate`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getDocumentType = (user) =>
  oauth2
    .fetch(`${api}/client/document/types`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getPreviewTemplate = (user, payload) =>
  oauth2
    .fetch(`${api}/client/mandrill/preview`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const unAssignTemplates = (user, payload) =>
  oauth2
    .fetch(`${api}/admin/task/unassignTemplate`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getContactSettings = (user, id) =>
  oauth2
    .fetch(`${api}/client/contactDetails?user_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateContactEmails = (user, payload) =>
  oauth2
    .fetch(`${api}/client/contactDetails/create`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getContactLetter = (user, id) =>
  oauth2
    .fetch(`${api}/client/address?user_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateContactLetter = (user, payload) =>
  oauth2
    .fetch(`${api}/client/address/create`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const enablePayment = (user) =>
  oauth2
    .fetch(`${api}/client/stripeConnects/enablePayment`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getStripeConnectDetails = (user) =>
  oauth2
    .fetch(`${api}/client/stripeConnects/detail`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getExpressAttachedDocuement = (id) =>
  oauth2
    .fetch(`${api}/expressPayment/invoiceDocument?document_id=${id}`, {
      method: "GET",
      headers: setHeaders("", false, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updatePaymentOption = (user, payload) =>
  oauth2
    .fetch(`${api}/admin/organization/update_payment_option`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateQBOAcknowledgement = (user, payload) =>
  oauth2
    .fetch(`${api}/admin/organization/qbo_disconnect_acknowledged`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getPaymentPreferences = (user) =>
  oauth2
    .fetch(`${api}/client/paymentPreferences/getPreferences`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updatePaymentPreferences = (user, payload) =>
  oauth2
    .fetch(`${api}/client/paymentPreferences/updatePreferences`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getStripeDashboardLink = (user) =>
  oauth2
    .fetch(`${api}/client/stripeConnects/dashboard`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const startExpressPayment = (user, key) =>
  oauth2
    .fetch(`${api}/expressPayment/start_payment`, {
      method: "GET",
      headers: setHeaders({ organization_key: key }, true, true),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getMergeVariablesList = (user, id) =>
  oauth2
    .fetch(`${api}/admin/mergeVariables/list?organization_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateMergeVariables = (user, payload) =>
  oauth2
    .fetch(`${api}/admin/mergeVariables/update`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getPlaidLinkToken = (user, id, sub_account_id) =>
  oauth2
    .fetch(
      `${api}/consumer/payment/plaidLinkToken?invoice_id=${id}&sub_account_id=${sub_account_id}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getPlaidStatus = (user, sub_account_id) =>
  oauth2
    .fetch(
      `${api}/consumer/payment/plaidStatus?sub_account_id=${sub_account_id}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const createPlaidPayment = (user, payload, sub_account_id) =>
  oauth2
    .fetch(
      `${api}/consumer/payment/createPlaidPayment?sub_account_id=${sub_account_id}`,
      {
        method: "POST",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({
          ...payload,
        }),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendPlaidData = (user, payload, sub_account_id) =>
  oauth2
    .fetch(
      `${api}/consumer/payment/plaidExchangeToken?sub_account_id=${sub_account_id}`,
      {
        method: "POST",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({
          ...payload,
        }),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const consumerLinkAccessToken = (user, sub_account_id) => {
  return oauth2
    .fetch(
      `${api}/consumer/payment/linkAccessToken?sub_account_id=${sub_account_id}`,
      {
        method: "GET",
        headers: setHeaders(user, true, true),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const updateMergeVarLogo = (user, id, payload) =>
  oauth2
    .fetch(`${api}/admin/mergeVariables/uploadLogo?organization_id=${id}`, {
      method: "POST",
      headers: setHeaders(user, true, false),
      body: payload,
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

//express payment plaid flow without auth header
export const expressPlaidStatus = (id, key) =>
  oauth2
    .fetch(`${api}/expressPayment/plaidStatus?invoice_id=${id}`, {
      method: "GET",
      headers: setHeaders({ organization_key: key }, true, true),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const expressPlaidLinkToken = (id, key) =>
  oauth2
    .fetch(`${api}/expressPayment/plaidLinkToken?invoice_id=${id}`, {
      method: "GET",
      headers: setHeaders({ organization_key: key }, true, true),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const expressSendPlaidData = (payload, key) =>
  oauth2
    .fetch(`${api}/expressPayment/plaidExchangeToken`, {
      method: "POST",
      headers: setHeaders({ organization_key: key }, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const expressCreatePlaidPayment = (payload, key) =>
  oauth2
    .fetch(`${api}/expressPayment/createPlaidPayment`, {
      method: "POST",
      headers: setHeaders({ organization_key: key }, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const expressLinkAccessToken = (key, invoiceId) =>
  oauth2
    .fetch(
      `${api}/expressPayment/plaidtokenbyaccesstok?invoice_id=${invoiceId}`,
      {
        method: "GET",
        headers: setHeaders({ organization_key: key }, true, true),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getConsumerPaymentDetails = (user, sub_account_id) =>
  oauth2
    .fetch(`${api}/consumer/payment/details?sub_account_id=${sub_account_id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getExpressPaymentDetails = (id, key) =>
  oauth2
    .fetch(`${api}/expressPayment/details?invoice_id=${id}`, {
      method: "GET",
      headers: setHeaders({ organization_key: key }, true, true),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

//express payment open apis for add/remove card //TO_DO
export const addCreaditCardFromExpress = (payload, key) =>
  oauth2
    .fetch(`${api}/expressPayment/addCard`, {
      method: "POST",
      headers: setHeaders({ organization_key: key }, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const expressRemoveCard = (payload, key) =>
  oauth2
    .fetch(`${api}/expressPayment/removeCard`, {
      method: "POST",
      headers: setHeaders({ organization_key: key }, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const expressDisconnectBank = (payload, key) =>
  oauth2
    .fetch(`${api}/expressPayment/disconnectBank`, {
      method: "POST",
      headers: setHeaders({ organization_key: key }, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const expressMakePayment = (payload, key) =>
  oauth2
    .fetch(`${api}/expressPayment/makePayment`, {
      method: "POST",
      headers: setHeaders({ organization_key: key }, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

//Add incoice apis
export const clientAddServices = (user, payload) =>
  oauth2
    .fetch(`${api}/client/services`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getServiceAccountList = (user) =>
  oauth2
    .fetch(`${api}/client/services/account_list`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getInvoiceRefundData = (user, id) =>
  oauth2
    .fetch(`${api}/client/refund/refund_data?invoice_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const invoiceRefundPayment = (user, payload) =>
  oauth2
    .fetch(`${api}/client/refund/payment`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getClientServices = (user, page, type) =>
  oauth2
    .fetch(`${api}/client/services?page=${page}&type=${type}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const invoiceClientSearch = (user, search) =>
  oauth2
    .fetch(`${api}/client/invoice/searchUser?query=${search}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientServicesSearch = (user, search) =>
  oauth2
    .fetch(`${api}/client/services/search?query=${search}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const creditTermsSearch = (user, search) =>
  oauth2
    .fetch(`${api}/client/terms/search_term?query=${search}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const addInvoice = (user, payload) =>
  oauth2
    .fetch(`${api}/client/invoice/create`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getInvoiceNumber = (user) =>
  oauth2
    .fetch(`${api}/client/invoice/getCreateData`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientUpdateServices = (user, payload) =>
  oauth2
    .fetch(`${api}/client/services/${payload.id}`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientPreviewInvoice = (user, payload) =>
  oauth2
    .fetch(`${api}/client/invoice/preview`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((response) => response.blob())
    .then((blob) => {
      return blob;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientDeletePaymentPlan = (user, id) => {
  return oauth2
    .fetch(`${api}/client/payment_plans/${id}`, {
      method: "DELETE",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};
export const clientDeleteInvoice = (user, payload) =>
  oauth2
    .fetch(`${api}/client/invoice/void`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const deleteInvoice = (user, invoiceId) =>
  oauth2
    .fetch(`${api}/client/invoice/delete?invoice_id=${invoiceId}`, {
      method: "DELETE",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getTermsListInSettings = (user) =>
  oauth2
    .fetch(`${api}/client/terms/terms_list`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAccountDaysPastDue = (user) =>
  oauth2
    .fetch(`${api}/client/org/acc_elg_vars`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientCreateTermsInSettings = (user, payload) =>
  oauth2
    .fetch(`${api}/client/terms/create_terms`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientUpdateTermsInSettings = (user, payload) =>
  oauth2
    .fetch(`${api}/client/terms/update_terms`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientUpdateIndividualTermsInSettings = (
  user,
  accountId,
  payload
) =>
  oauth2
    .fetch(`${api}/client/consumers/${accountId}/update_term`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getMiscellaneousInSettings = (user) =>
  oauth2
    .fetch(`${api}/client/miscellaneous/getMiscellaneous`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getConsumerMiscellaneousInSettings = (user) =>
  oauth2
    .fetch(`${api}/consumer/miscellaneous`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getLetterMergeVariables = (user, invoice_id, userId) =>
  oauth2
    .fetch(
      `${api}/client/invoice/letterMergeVariables?invoice_id=${invoice_id}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAccountLetterMergeVars = (user, userId) =>
  oauth2
    .fetch(`${api}/client/invoice/letterMergeVariables?user_id=${userId}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientUpdateMiscellaneousInSettings = (user, payload) =>
  oauth2
    .fetch(`${api}/client/miscellaneous/update_miscellaneous`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientUpdateAccountNumber = (user, payload, data) =>
  oauth2
    .fetch(
      `${api}/users/${data.id}/update_account_no?account_number=${data.account_number}`,
      {
        method: "PUT",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({
          ...payload,
        }),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSuperGoLiveDate = (user, id) =>
  oauth2
    .fetch(`${api}/admin/organization/get_live_date?organization_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateSuperGoLiveDate = (user, payload) =>
  oauth2
    .fetch(`${api}/admin/organization/update_live_date`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSsoGoLiveDate = (user, orgUrl) =>
  oauth2
    .fetch(`${api}/client/organization/get_live_date?org_url=${orgUrl}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateSsoGoLiveDate = (user, payload) =>
  oauth2
    .fetch(`${api}/client/organization/update_live_date`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getOpenInvoicesList = (user, id, isCollection = false, page) =>
  oauth2
    .fetch(
      `${api}/client/invoice/open_invoices?user_id=${id}&&is_collection=${isCollection}&page=${page}`,
      {
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const getPaymentPlanInvoiceList = (
  user,
  id,
  sort_by = "",
  order_by = "",
  page = 0
) => {
  const sortQuery =
    sort_by && order_by
      ? `&sort_by=${encodeURIComponent(sort_by)}&order_by=${encodeURIComponent(order_by)}`
      : "";
  const paginationQuery = `&page=${page}`;
  return oauth2
    .fetch(
      `${api}/client/invoice/payplaninvoices?user_id=${id}${sortQuery}${paginationQuery}`,
      {
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getPaymentPlanList = (
  user,
  id,
  sort_by = "",
  order_by = "",
  filters = {},
  page = 0
) => {
  const sortQuery =
    sort_by && order_by
      ? `&sort_by=${encodeURIComponent(sort_by)}&order_by=${encodeURIComponent(order_by)}`
      : "";
  const paginationQuery = `&page=${page}`;
  const filterPairs = [
    ["status", filters?.status],
    ["from_date", filters?.from_date],
    ["to_date", filters?.to_date],
    ["tasks", filters?.tasks],
    ["task_status", filters?.task_status],
  ];
  const filtersQuery = filterPairs
    .filter(([, val]) => val != null && String(val).trim() !== "")
    .map(
      ([key, val]) =>
        `&${encodeURIComponent(key)}=${encodeURIComponent(String(val).trim())}`
    )
    .join("");
  return oauth2
    .fetch(
      `${api}/client/payment_plans?user_id=${id}${sortQuery}${paginationQuery}${filtersQuery}`,
      {
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};
export const getConsumerPaymentPlanDetails = (user, id) =>
  oauth2
    .fetch(`${api}/consumer/payment_plan/detail?id=${id}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getDownloadConsumerPaymentPlan = (user, id) =>
  oauth2
    .fetch(`${api}/consumer/payment_plan/document?document_id=${id}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getPaymentPlanLById = (user, id) =>
  oauth2
    .fetch(`${api}/client/payment_plans/${id}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const createPaymentPlan = (user, payload) =>
  oauth2
    .fetch(`${api}/client/payment_plans`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });
export const getConsumerPaymentPlans = (user, sub_account_id) =>
  oauth2
    .fetch(`${api}/consumer/payment_plans?sub_account_id=${sub_account_id}`, {
      method: "GET",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const markPaymentPlanAccepted = (user, id) =>
  oauth2
    .fetch(`${api}/client/payment_plans/${id}/accept`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        is_accepted: true,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getClientCreditMemoList = (
  user,
  id,
  sort_by = "",
  order_by = "",
  filters = {}
) => {
  const sortQuery =
    sort_by && order_by
      ? `&sort_by=${encodeURIComponent(sort_by)}&order_by=${encodeURIComponent(order_by)}`
      : "";
  const filterPairs = [
    ["status", filters?.status],
    ["from_date", filters?.from_date],
    ["to_date", filters?.to_date],
    ["customer_name", filters?.customer_name],
  ];
  const filtersQuery = filterPairs
    .filter(([, val]) => val != null && String(val).trim() !== "")
    .map(
      ([key, val]) =>
        `&${encodeURIComponent(key)}=${encodeURIComponent(String(val).trim())}`
    )
    .join("");
  return oauth2
    .fetch(
      `${api}/client/credit_memo/credit_memo_list?user_id=${id}${sortQuery}${filtersQuery}`,
      {
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getGenerateStatementList = (
  user,
  id,
  sort_by = "",
  order_by = "",
  filters = {},
  page = 0
) => {
  const sortQuery =
    sort_by && order_by
      ? `&sort_by=${encodeURIComponent(sort_by)}&order_by=${encodeURIComponent(order_by)}`
      : "";
  const filterPairs = [
    ["month", filters?.month],
    ["from_date", filters?.from_date],
    ["to_date", filters?.to_date],
  ];
  const filtersQuery = filterPairs
    .filter(([, val]) => val != null && String(val).trim() !== "")
    .map(
      ([key, val]) =>
        `&${encodeURIComponent(key)}=${encodeURIComponent(String(val).trim())}`
    )
    .join("");
  return oauth2
    .fetch(
      `${api}/client/statement/get_statement_list?id=${id}&page=${page}${sortQuery}${filtersQuery}`,
      {
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const downloadStatement = (user, id) =>
  oauth2
    .fetch(`${api}/client/statement/get_statement_file?statement_id=${id}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const emailLetterStatement = (user, payload) =>
  oauth2
    .fetch(`${api}/client/statement/send_statement`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const generateStatement = (user, id, from, to) =>
  oauth2
    .fetch(
      `${api}/client/statement/create_stmt?id=${id}&from_date=${from}&to_date=${to}`,
      {
        method: "POST",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({}),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getCreditMemoDetails = (user, id) =>
  oauth2
    .fetch(`${api}/client/credit_memo/cm_detail?id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const addCreditMemoNote = (user, payload) =>
  oauth2
    .fetch(`${api}/client/credit_memo_notes`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const addPaymentPlanNotes = (user, payload) =>
  oauth2
    .fetch(`${api}/client/payment_plans/${payload.payment_plan_id}/notes`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const getCreditMemoNumber = (user) =>
  oauth2
    .fetch(`${api}/client/credit_memo/getCMCreateData`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const addCreditMemo = (user, payload) =>
  oauth2
    .fetch(`${api}/client/credit_memo/create_cm`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendPastDueRemainder = (user, payload) =>
  oauth2
    .fetch(`${api}/client/invoice/past_due_task`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const cancelPastDueRemainder = (user, payload) =>
  oauth2
    .fetch(
      `${api}/client/invoice/cancel_past_due_task?task_id=${payload.task_id}`,
      {
        method: "POST",
        headers: setHeaders(user, true, false),
        body: JSON.stringify({
          ...payload,
        }),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const deleteClientsCreditMemo = (user, id) =>
  oauth2
    .fetch(`${api}/client/credit_memo/delete_cm?credit_memo_id=${id}`, {
      method: "DELETE",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getOrgMergeVeriableData = (user, id) =>
  oauth2
    .fetch(`${api}/client/consumers/${id}/org_merge_vars`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const signInWithIntuit = () =>
  oauth2
    .fetch(`${api}/qb_sso?return_url=${window.location.origin}`, {
      method: "GET",
      headers: setHeaders(null, false, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const setOauthSSOObj = (payload) => {
  if (
    (payload.email != "null" && payload.email != null && payload.email != "") ||
    (payload.id_token != "null" &&
      payload.id_token != null &&
      payload.id_token != "") ||
    (payload.openid_id != "null" &&
      payload.openid_id != null &&
      payload.openid_id != "")
  ) {
    oauthGeneration += 1;
    const gen = oauthGeneration;
    oauth2 = new OAuth2({
      grantType: "password",
      clientId: clientID,
      clientSecret: clientSecret,
      username: payload.email,
      id_token: payload.id_token,
      openid_id: payload.openid_id,
      tokenEndpoint: `${api}/oauth/token?organization_key=${payload.organization_key}&id_token=${payload.id_token}&openid_id=${payload.openid_id}&username=${payload.email}&is_switch=${payload.is_switch}`,
      onTokenUpdate: (token) => syncTokensToCookies(token, gen),
      onAuthError: () => emitOauthError(),
    });
  } else {
    // window.location.href = "/login";
  }
};

export const setOauthSSOObjNewUser = (payload) => {
  oauthGeneration += 1;
  const gen = oauthGeneration;
  oauth2 = new OAuth2({
    grantType: "password",
    clientId: clientID,
    clientSecret: clientSecret,
    username: payload.email,
    password: payload.password,
    tokenEndpoint: `${api}/oauth/token?organization_key=${payload.organization_key}&username=${payload.email}&password=${payload.password}`,
    onTokenUpdate: (token) => syncTokensToCookies(token, gen),
    onAuthError: () => emitOauthError(),
  });
};

export const reverseCreditMemo = (user, payload) =>
  oauth2
    .fetch(
      `${api}/client/credit_memo/reverse_cm?invoice_id=${payload.invoice_id}&txn_id=${payload.txn_id}&credit_memo_number=${payload.credit_memo_number}`,
      {
        method: "delete",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAppliedCredit = (user, type) => {
  let url =
    type === "Account"
      ? `${api}/client/credit_memo/apply_credit_memo?user_id=${user}`
      : `${api}/client/credit_memo/apply_credit_memo?user_id=${user.user_id}`;
  let tempVar = type === "Account" ? user : user.user_id;
  return oauth2
    .fetch(url, {
      method: "GET",
      headers: setHeaders(tempVar, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const saveSubdomain = (user, payload) =>
  oauth2
    .fetch(`${api}/save_subdomain`, {
      method: "POST",
      headers: setHeaders(user, true, true, payload.organization_key),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getOrganizationData = () => {
  const prefix = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const themeUrl = prefix ? `${prefix}/theme.json` : "/theme.json";
  return fetch(themeUrl)
    .then((res) => {
      if (!res.ok) return {};
      return res.json().catch(() => ({}));
    })
    .catch(() => ({}))
    .then((theme) => {
      if (theme && theme.organization_key) return theme;
      return {};
    });
};

// export const getOrgDetail = (user) => {
//   oauth2
//     .fetch(`${api}/client/org/detail?org_url=${getBaseUrl()}`, {
//       method: "GET",
//       headers: setHeaders(
//         user == null ? null : user, // user data
//         user == null ? false : true, // use auth
//         false // use JSON
//       ),
//     })
//     .then((response) => {
//       alert("response==========:", response);
//       if (response) {
//         alert("is resp==========:", response);
//         response.json();
//       }
//     })
//     .then(function (data) {
//       alert("data==========:", typeof data);
//       if (data) {
//         alert("is data==========:", typeof data);
//       }
//       return data;
//     })
//     .catch((error) => {
//       alert("error==========:", error);
//       return error;
//     });
// };

export const ssoAddOrganization = (user, payload) =>
  oauth2
    .fetch(`${api}/client/org/update`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getOrgDetails = (user) =>
  oauth2
    .fetch(`${api}/client/org/detail?org_url=${getBaseUrl()}`, {
      method: "GET",
      headers: setHeaders(
        user == null ? null : user, // user data
        true, // use auth
        false // use JSON
      ),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getRealmIdFromQB = (realmid) =>
  oauth2
    .fetch(`${api}/launch?realmid=${realmid}`, {
      method: "GET",
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getEmpInfo = (token, org_key) => {
  const theme = JSON.parse(localStorage.getItem("themeData"));
  const orgKey = org_key ? org_key : theme.organization_key;
  return oauth2
    .fetch(
      `${api}/client/employee/info?registration_token=${token}&org_key=${orgKey}`,
      {
        method: "GET",
      }
    )
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
};

export const resetPasswords = (user, employee_id) =>
  oauth2
    .fetch(`${api}/client/employee/resetPassword`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        employee_id: employee_id,
      }),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      // console.error("error==========:", error);
      return { errors: error.message };
    });
export const invitation = (user, employee_id) =>
  oauth2
    .fetch(`${api}/client/employee/invitation`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        employee_id: employee_id,
      }),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const userDisable = (user, employee_id) =>
  oauth2
    .fetch(`${api}/client/employee/disable`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        employee_id: employee_id,
      }),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const editUser = (user, id) =>
  oauth2
    .fetch(`${api}/client/employee/${id}/data`, {
      method: "GET",
      headers: setHeaders(user.user_id, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const assignedConstactsApi = (user, id) =>
  oauth2
    .fetch(`${api}/client/consumer/unassigned?employee_id=${id}`, {
      method: "GET",
      headers: setHeaders(user.user_id, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const getMergeVariablesListClient = (user, id) =>
  oauth2
    .fetch(`${api}/client/mergeVariables/list?organization_id=${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const updateMergeVariablesClient = (user, payload) =>
  oauth2
    .fetch(`${api}/client/mergeVariables/update`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const updateW9Form = (user, payload) =>
  oauth2
    .fetch(`${api}/client/org/w9_form`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const paymentPortalUrl = (user, payload) =>
  oauth2
    .fetch(`${api}/client/mergeVariables/pay_portal`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const mergeVariables_org_logo = (user, payload) =>
  oauth2
    .fetch(`${api}/client/mergeVariables/org_logo`, {
      method: "PUT",
      headers: setHeaders(user, true, false),
      body: payload,
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const mergeVar_pdfPreview = (user, employee_id) =>
  oauth2
    .fetch(`${api}/client/mergeVariables/pdf_preview`, {
      method: "POST",
      headers: setHeaders(user, true, true),
    })
    .then((response) => response.blob())
    .then((blob) => {
      return blob;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const update_profile = (user, payload) =>
  oauth2
    .fetch(`${api}/client/org/update_profile`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

// export const getTestCredsFullPortal = (user) =>
//   oauth2
//     .fetch(`${api}/client/organization/get_test_creds?full_portal=true`, {
//       method: "GET",
//       headers: setHeaders(user, true, false),
//     })
//     .then((res) => res.json())
//     .catch((error) => {
//       console.error("error==========:", error);
//     });

export const usersAgreement = (id, user) => {
  const orgKey = JSON.parse(localStorage.getItem("switchOrgDetails"));
  let userID = id || user.user_id || user.id;
  return oauth2
    .fetch(`${api}/users/${userID}/agreement`, {
      method: "POST",
      headers: setHeaders(user, true, true, orgKey.organization_key),
      body: JSON.stringify({ accepted: true }),
    })
    .then((response) => response.json())
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const updateAccountPlacementEligibility = (user, payload) =>
  oauth2
    .fetch(`${api}/client/org/acc_elg_vars`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientMandrillRequest = (payload) =>
  oauth2
    .fetch(`${api}/client/mandrill/leadRequest`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientPlacementTerm = (user) =>
  oauth2
    .fetch(`${api}/client/org/placementTerm`, {
      headers: setHeaders(user, true, true),
      method: "POST",
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const cancelPlacementFromCollection = (user, id) =>
  oauth2
    .fetch(`${api}/client/invoice/cancelPlacement?invoice_id=${id}`, {
      headers: setHeaders(user, true, true),
      method: "PUT",
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const acceptConsumerPaymentPlan = (user, payload) =>
  oauth2
    .fetch(`${api}/consumer/payment_plan/accept`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const contactUs = (user, payload) =>
  oauth2
    .fetch(`${api}/contact_us`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const updateAccountingSystem = (user, payload) =>
  oauth2
    .fetch(`${api}/client/org/update_accounting_system`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
export const getAccountingSystem = (user) =>
  oauth2
    .fetch(`${api}/client/org/accounting_system`, {
      method: "GET",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getDashboardTotals = (user, payload) =>
  oauth2
    .fetch(`${api}/dashboard/totals?scope=${payload}`, {
      method: "GET",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const dashobardArAgingReport = (
  user,
  sort_by,
  sort_key,
  page,
  mostRiskAccounts,
  parent_account,
  search
) => {
  const encodedSearch = encodeURIComponent(search ?? "");
  return oauth2
    .fetch(
      `${api}/dashboard/arAgingReports?sort_by=${sort_by}&order=${sort_key}&page=${page}&with_most_risk=${mostRiskAccounts}&parent_accounts=${parent_account}&search=${encodedSearch}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const dashboardUpcomingActivities = (user, page, filter_by, user_ids) =>
  oauth2
    .fetch(
      `${api}/dashboard/upcoming_activities?page=${page}&filter_by=${filter_by}&user_ids=${user_ids}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const dashboardRecentActivities = (user, page, filter_by, user_ids) =>
  oauth2
    .fetch(
      `${api}/dashboard/recent_events?page=${page}&filter_by=${filter_by}&user_ids=${user_ids}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getDashboardPddReport = (user) =>
  oauth2
    .fetch(`${api}/dashboard/i2cAndPddReport`, {
      method: "GET",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const AddStartTask = (user, payload) =>
  oauth2
    .fetch(`${api}/client/invoice/past_due_task`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getRecurringInvoiceList = (
  user,
  page,
  sort_direction,
  sort_column,
  filterParams = {}
) => {
  let url = `${api}/client/recurring_invoice_schedules?page=${page}&sort_direction=${sort_direction}&sort_column=${sort_column}`;
  if (filterParams && typeof filterParams === "object") {
    Object.entries(filterParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        url += `&${key}=${encodeURIComponent(value)}`;
      }
    });
  }

  return oauth2
    .fetch(url, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("API Error:", error);
      throw error;
    });
};

export const recurringBulkAction = (user, payload) =>
  oauth2
    .fetch(`${api}/client/recurring_invoice_schedules/bulk_action`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const addRecurringNote = (
  user,
  recurring_invoice_schedule_id,
  payload
) =>
  oauth2
    .fetch(
      `${api}/client/recurring_schedule_notes/${recurring_invoice_schedule_id}/create_note`,
      {
        method: "POST",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({
          ...payload,
        }),
      }
    )
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getRecurringInvoiceNotes = (user, recurring_invoice_schedule_id) =>
  oauth2
    .fetch(
      `${api}/client/recurring_schedule_notes/${recurring_invoice_schedule_id}/get_notes`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const clientPreviewRecurringInvoice = (user, payload) =>
  oauth2
    .fetch(`${api}/client/recurring_invoice_schedules/preview`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((response) => response.blob())
    .then((blob) => {
      return blob;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getRecurringInvoiceHistory = (
  user,
  recurringInvoiceScheduleId,
  page,
  sort_direction,
  sort_column
) => {
  let url = `${api}/client/recurring_invoice_schedules/${recurringInvoiceScheduleId}/history?page=${page}&sort_column=${sort_column}&sort_direction=${sort_direction}`;

  return oauth2
    .fetch(url, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateManageRecurringInvoice = (user, payload) =>
  oauth2
    .fetch(
      `${api}/client/recurring_invoice_schedules/manage_variable_services`,
      {
        method: "PUT",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({
          ...payload,
        }),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateRecurringEscalation = (user, payload) =>
  oauth2
    .fetch(`${api}/client/recurring_invoice_schedules/update_escalated_to`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getElavonSSHToken = (
  user,
  amount,
  type,
  saveCard,
  invoiceNumber,
  ssl_first_name,
  ssl_last_name,
  ssl_email,
  ssl_address,
  ssl_zip
) => {
  const params = new URLSearchParams({
    amount,
    type,
    get_token: saveCard,
    invoice_number: invoiceNumber,
    ssl_first_name,
    ssl_last_name,
    ssl_email,
    ssl_address,
    ssl_zip,
  });

  return oauth2
    .fetch(
      `${api}/client/converge_payments/session_token?${params.toString()}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((res) => res.json())
    .then((data) => data)
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getPaymentAndStatusList = (user) =>
  oauth2
    .fetch(`${api}/client/payments/payment_type_and_status`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    });

export const getSubAccountList = (user, user_id) =>
  oauth2
    .fetch(
      `${api}/dashboard/parentAccountDetailedInvoices?parent_user_id=${user_id}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    });

export const getConsumerSubAccountList = (user, user_id) =>
  oauth2
    .fetch(`${api}/consumer/getSubAccounts?id=${user_id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    });

export const updateApplicationFees = (user, payload) =>
  oauth2
    .fetch(`${api}/admin/organization/stripe_fees`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getMiscellaneousMini = (user) =>
  oauth2
    .fetch(`${api}/client/miscellaneous/getMiscellaneousMini`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    });

export const getTeamMembersMini = (user, isAccount, page = 0, search = "") => {
  const params = new URLSearchParams({
    page,
    is_account: isAccount,
  });
  if (search && search.trim() !== "") {
    params.append("q", search.trim());
  }
  return oauth2
    .fetch(`${api}/client/employee/list_mini?${params.toString()}`, {
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getOrgDetailsMini = (user) =>
  oauth2
    .fetch(`${api}/client/org/detail_mini?org_url=${getBaseUrl()}`, {
      method: "GET",
      headers: setHeaders(
        user == null ? null : user, // user data
        true, // use auth
        false // use JSON
      ),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const removeElavonCard = (user, payload) =>
  oauth2
    .fetch(`${api}/client/delete_card_converge`, {
      method: "DELETE",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getExpressElavonSSHToken = (
  invoice_id,
  amount,
  saveCard,
  key,
  type,
  invoice_number
) => {
  const params = new URLSearchParams({
    invoice_id,
    amount,
    get_token: saveCard,
    type,
    invoice_number,
  });
  return oauth2
    .fetch(`${api}/expressPayment/getSessionToken?${params.toString()}`, {
      method: "GET",
      headers: setHeaders({ organization_key: key }, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const removeExpressElavonCard = (payload, key) =>
  oauth2
    .fetch(`${api}/expressPayment/removeCard`, {
      method: "DELETE",
      headers: setHeaders({ organization_key: key }, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getConsumerElavonSSHToken = (
  user,
  amount,
  saveCard,
  invoiceNumber,
  type
) => {
  const params = new URLSearchParams({
    amount,
    get_token: saveCard,
    invoice_number: invoiceNumber,
    type: type,
  });
  return oauth2
    .fetch(`${api}/consumer/get_session_token?${params.toString()}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const removeConsumerElavonCard = (user, payload) =>
  oauth2
    .fetch(`${api}/consumer/removeCard`, {
      method: "DELETE",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getPortalStatus = (user) =>
  oauth2
    .fetch(`${api}/client/payment/portal_status`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const saveProcessorSelection = (user, payload) =>
  oauth2
    .fetch(`${api}/client/payment/save_processor_selection`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getTimezoneOptions = (user) =>
  oauth2
    .fetch(`${api}/client/converge_payments/timezone_options`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const saveElavonForm = (user, payload) =>
  oauth2
    .fetch(`${api}/client/converge_payments/save_contact_info`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getElavonFormDetails = (user, payload) =>
  oauth2
    .fetch(`${api}/client/converge_payments/contact_info`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getHistoryPaymentDownload = (
  user,
  from_date,
  to_date,
  min_amount,
  max_amount,
  payment_method,
  status,
  user_id,
  searchText
) => {
  const params = new URLSearchParams();
  if (from_date) params.append("from_date", from_date);
  if (to_date) params.append("to_date", to_date);
  if (min_amount !== undefined && min_amount !== null && min_amount !== "")
    params.append("min_amount", min_amount);
  if (max_amount !== undefined && max_amount !== null && max_amount !== "")
    params.append("max_amount", max_amount);
  if (payment_method) params.append("payment_method", payment_method);
  if (status) params.append("status", status);
  if (user_id) params.append("user_id", user_id);
  if (searchText) params.append("searchText", searchText);

  const url = `${api}/client/paymentHistory/download?${params.toString()}`;

  return oauth2
    .fetch(url, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getMailPreview = (user, mail_id) =>
  oauth2
    .fetch(`${api}/client/mandrill/getMailHtmlPreview?mail_id=${mail_id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.text())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateSurchargeAccounts = (user, payload) =>
  oauth2
    .fetch(`${api}/client/org/update_surcharge_accounts`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getIncomeAccountsList = (user) =>
  oauth2
    .fetch(`${api}/client/services/other_current_asset_accounts`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getQboStripeSettlementAccounts = (user) =>
  oauth2
    .fetch(`${api}/client/qbo_stripe_settlement_accounts`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getQboStripeSettlementAccountOptions = (user) =>
  oauth2
    .fetch(`${api}/client/qbo_stripe_settlement_accounts/account_options`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateQboStripeSettlementAccounts = (user, payload) =>
  oauth2
    .fetch(`${api}/client/qbo_stripe_settlement_accounts`, {
      method: "PATCH",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getQboSyncCompatibility = (user) =>
  oauth2
    .fetch(`${api}/client/reports/qbo_sync_compatibility`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const addCustomTask = (user, payload) =>
  oauth2
    .fetch(`${api}/client/custom_tasks`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getInvoiceCustomTasks = (
  user,
  page,
  sortBy,
  orderBy,
  user_id,
  filterBy = ""
) =>
  oauth2
    .fetch(
      `${api}/client/custom_tasks?page=${page}&sort_by=${sortBy}&order_by=${orderBy}&user_id=${user_id}${filterBy ? filterBy : ""}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getMergeVariablesTemplate = (user, template_slug) =>
  oauth2
    .fetch(
      `${api}/client/mandrill/mergeVariables?template_slug=${template_slug}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateCustomTask = (user, task_id, payload) =>
  oauth2
    .fetch(`${api}/client/custom_tasks/${task_id}/update_status`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateTeamMembers = (user, account_id, payload) =>
  oauth2
    .fetch(`${api}/client/consumers/${account_id}/team_members`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const saveMandrillTemplate = (user, payload) =>
  oauth2
    .fetch(`${api}/client/mandrill/template`, {
      method: "PUT",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getConsumerActivities = (
  user,
  invoice_ids = "",
  filter,
  page,
  user_id
) =>
  oauth2
    .fetch(
      `${api}/client/consumer/activities?${invoice_ids ? invoice_ids : ""}filter=${filter}&page=${page}&user_id=${user_id}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const syncMgDataToQbo = (user) =>
  oauth2
    .fetch(`${api}/qb/sync_mg_data_to_qbo`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getConsumerAccountTransactions = (
  user,
  from_date,
  to_date,
  user_id,
  page,
  sort_by = "",
  order_by = "",
  filters = {}
) => {
  const params = new URLSearchParams();
  const resolvedFrom = from_date || filters?.from_date;
  const resolvedTo = to_date || filters?.to_date;
  if (resolvedFrom) params.append("from_date", resolvedFrom);
  if (resolvedTo) params.append("to_date", resolvedTo);
  if (user_id) params.append("user_id", user_id);
  if (page != null && page !== "") {
    params.append("page", String(page));
  }
  if (sort_by && order_by) {
    params.append("sort_by", sort_by);
    params.append("order_by", order_by);
  }
  const filterPairs = [
    ["status", filters?.status],
    ["type", filters?.type],
    ["min_amount", filters?.min_amount],
    ["max_amount", filters?.max_amount],
    ["customer_name", filters?.customer_name],
  ];
  filterPairs.forEach(([key, val]) => {
    if (val != null && String(val).trim() !== "") {
      params.append(key, String(val).trim());
    }
  });

  return oauth2
    .fetch(
      `${api}/client/consumers/${user_id}/account_transactions?${params.toString()}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const savePaymentDeposit = (user, payload) =>
  oauth2
    .fetch(`${api}/client/deposits`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getPaymentDeposit = (
  user,
  page,
  limit,
  search,
  status,
  to_date,
  from_date
) =>
  oauth2
    .fetch(
      `${api}/client/deposits?page=${page}&limit=${limit}&search=${search}&status=${status}&to_date=${to_date}&from_date=${from_date}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getMerchantSettlements = (user, params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => query.append(`${key}[]`, item));
    } else if (value !== "" && value != null) {
      query.append(key, value);
    }
  });
  return oauth2
    .fetch(`${api}/client/merchant_settlements?${query}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getMerchantSettlementById = (user, id) =>
  oauth2
    .fetch(`${api}/client/merchant_settlements/${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateMerchantSettlementLines = (user, id, payload) =>
  oauth2
    .fetch(`${api}/client/merchant_settlements/${id}/lines`, {
      method: "PATCH",
      headers: setHeaders(user, true, true),
      body: JSON.stringify(payload),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const createMerchantSettlementQboDeposit = (user, id) =>
  oauth2
    .fetch(`${api}/client/merchant_settlements/${id}/create_qbo_deposit`, {
      method: "POST",
      headers: setHeaders(user, true, true),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getPaymentDepositById = (user, id) =>
  oauth2
    .fetch(`${api}/client/deposits/${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updatePaymentDeposit = (user, id, payload) =>
  oauth2
    .fetch(`${api}/client/deposits/${id}`, {
      method: "PATCH",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const deletePaymentDeposit = (user, id) =>
  oauth2
    .fetch(`${api}/client/deposits/${id}`, {
      method: "DELETE",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getPaymentDepositCreateData = (user) =>
  oauth2
    .fetch(`${api}/client/deposits/create_data`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getAdminMergeVariables = (user) =>
  oauth2
    .fetch(`${api}/client/admins/merge_variables`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const makeDepositPayment = (user, payload) =>
  oauth2
    .fetch(`${api}/client/deposit_payments`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getDepositRefundList = (user, deposit_id) =>
  oauth2
    .fetch(
      `${api}/client/deposit_payments/get_payments_to_refund?deposit_id=${deposit_id}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const makeDepositRefundPayment = (user, deposit_id, payload) =>
  oauth2
    .fetch(`${api}/client/deposit_payments/${deposit_id}/refund_payment`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getDepositCancelList = (user, deposit_id) =>
  oauth2
    .fetch(
      `${api}/client/deposit_payments/get_payments_to_cancel?deposit_id=${deposit_id}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const makeDepositCancelPayment = (user, deposit_payment_id, payload) =>
  oauth2
    .fetch(
      `${api}/client/deposit_payments/${deposit_payment_id}/cancel_payment`,
      {
        method: "POST",
        headers: setHeaders(user, true, true),
        body: JSON.stringify({
          ...payload,
        }),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSalesUserDepositList = (
  user,
  page,
  limit,
  search,
  status,
  to_date,
  from_date
) =>
  oauth2
    .fetch(
      `${api}/sales_user/deposits?page=${page}&limit=${limit}&search=${search}&status=${status}&to_date=${to_date}&from_date=${from_date}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSalesUserDepositById = (user, id) =>
  oauth2
    .fetch(`${api}/sales_user/deposit/${id}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSalesUserDepositCreateData = (user) =>
  oauth2
    .fetch(`${api}/sales_user/deposit/create_data`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const updateSalesUserPaymentDeposit = (user, id, payload) =>
  oauth2
    .fetch(`${api}/sales_user/deposit/${id}`, {
      method: "PATCH",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const deleteSalesUserPaymentDeposit = (user, id) =>
  oauth2
    .fetch(`${api}/sales_user/deposit/${id}`, {
      method: "DELETE",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const saveSalesUserPaymentDeposit = (user, payload) =>
  oauth2
    .fetch(`${api}/sales_user/deposit`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const makeSalesUserDepositPayment = (user, payload) =>
  oauth2
    .fetch(`${api}/sales_user/deposit_payments`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSalesUserElavonSSHToken = (
  user,
  amount,
  type,
  saveCard,
  invoiceNumber,
  ssl_first_name,
  ssl_last_name,
  ssl_email,
  ssl_address,
  ssl_zip
) => {
  const params = new URLSearchParams({
    amount,
    type,
    get_token: saveCard,
    invoice_number: invoiceNumber,
    ssl_first_name,
    ssl_last_name,
    ssl_email,
    ssl_address,
    ssl_zip,
  });

  return oauth2
    .fetch(
      `${api}/sales_user/converge_payments/session_token?${params.toString()}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((res) => res.json())
    .then((data) => data)
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const getSalesUserProfile = (user) => {
  let id = user.user_id || user.id;
  return oauth2
    .fetch(`${api}/sales_user/profile`, {
      method: "GET",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const updateSalesUserProfile = (user, clientUpdate) =>
  oauth2
    .fetch(`${api}/sales_user/update_profile`, {
      method: "PATCH",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        user: {
          ...clientUpdate,
        },
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSalesUserMandrillTemplate = (user, templateSlug, type) =>
  oauth2
    .fetch(
      `${api}/sales_user/mandrill/getTemplateList?template=${templateSlug}&type=${type}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSalesUserMergeVariablesTemplate = (user, template_slug) =>
  oauth2
    .fetch(
      `${api}/sales_user/mandrill/mergeVariables?template_slug=${template_slug}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSalesUserMergeVariables = (user, name) =>
  oauth2
    .fetch(`${api}/sales_user/mandrill/getMergeVariable?name=${name}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSalesUserMergeVariablesList = (user) =>
  oauth2
    .fetch(`${api}/sales_user/merge_variables`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSalesUserPreviewTemplate = (user, payload) =>
  oauth2
    .fetch(`${api}/sales_user/mandrill/preview`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendSalesUserMandrillTemplate = (user, payload, userId) =>
  oauth2
    .fetch(`${api}/sales_user/mandrill/sendMailManually?user_id=${userId}`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getConsumersList = (user, search_term, page, limit = 20) =>
  oauth2
    .fetch(
      `${api}/client/consumers/list?q=${encodeURIComponent(search_term ?? "")}&page=${page ?? 1}&limit=${limit}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getConsumersInvoices = (
  user,
  id,
  search_term,
  page,
  filter_by_or_limit,
  sort_by = "",
  order_by = "",
  filters = {},
  limit = 20
) => {
  let filter_by = "";
  let resolvedLimit = limit;
  if (typeof filter_by_or_limit === "number") {
    resolvedLimit = filter_by_or_limit;
  } else if (filter_by_or_limit != null && filter_by_or_limit !== "") {
    filter_by = filter_by_or_limit;
  }
  const params = new URLSearchParams();
  params.append("page", String(page ?? 0));
  params.append("limit", String(resolvedLimit));
  if (search_term) {
    params.append("q", search_term);
  }
  if (filter_by) {
    params.append("filter_by", filter_by);
  }
  if (sort_by && order_by) {
    params.append("sort_by", sort_by);
    params.append("order_by", order_by);
  }
  const filterPairs = [
    ["from_date", filters?.from_date],
    ["to_date", filters?.to_date],
    ["due_from_date", filters?.due_from_date],
    ["due_to_date", filters?.due_to_date],
    ["min_balance", filters?.min_balance],
    ["max_balance", filters?.max_balance],
    ["invoice_number", filters?.invoice_number],
    ["customer_name", filters?.customer_name],
  ];
  filterPairs.forEach(([key, val]) => {
    if (val != null && String(val).trim() !== "") {
      params.append(key, String(val).trim());
    }
  });
  return oauth2
    .fetch(`${api}/client/consumers/${id}/invoices?${params.toString()}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const applyDepositToInvoice = (user, payload) =>
  oauth2
    .fetch(`${api}/client/deposits/apply_to_invoice`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({
        ...payload,
      }),
    })
    .then((res) => res.json())
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getDepositForExpressPayment = (key, depositNumber) =>
  oauth2
    .fetch(
      `${api}/expressDeposit/getDepositByDepositNumber?deposit_number=${depositNumber}&within_invoice_detail=true`,
      {
        method: "GET",
        headers: setHeaders({ organization_key: key }, true, false),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getDepositExpressSessionToken = (
  key,
  deposit_id,
  type,
  amount,
  get_token,
  invoice_number,
  ssl_first_name,
  ssl_last_name,
  ssl_email,
  ssl_address,
  ssl_zip
) => {
  const params = new URLSearchParams({
    deposit_id,
    type,
    amount,
    get_token,
    invoice_number,
    ssl_first_name,
    ssl_last_name,
    ssl_email,
    ssl_address,
    ssl_zip,
  });
  return oauth2
    .fetch(`${api}/expressDeposit/getSessionToken?${params.toString()}`, {
      method: "GET",
      headers: setHeaders({ organization_key: key }, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });
};

export const expressDepositMakePayment = (payload, key) =>
  oauth2
    .fetch(`${api}/expressDeposit/makePayment`, {
      method: "POST",
      headers: setHeaders({ organization_key: key }, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const consumerInvoiceReview = (user, payload) =>
  oauth2
    .fetch(`${api}/consumer/invoice/review`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const expressInvoiceReview = (organizationKey, payload) =>
  oauth2
    .fetch(`${api}/expressPayment/submitInvoiceReview`, {
      method: "POST",
      headers: setHeaders({ organization_key: organizationKey }, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getReceiptPreview = (user, deposit_payment_id) =>
  oauth2
    .fetch(
      `${api}/client/deposit_payments/${deposit_payment_id}/receipt_preview`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then(async (response) => {
      const contentType = (
        response.headers.get("content-type") || ""
      ).toLowerCase();
      if (
        !response.ok ||
        contentType.includes("application/json") ||
        contentType.includes("text/html")
      ) {
        try {
          const errBody = await response.json();
          return {
            error: true,
            message:
              errBody.message ||
              errBody.error ||
              "Unable to load receipt preview",
            status_code: response.status,
            ...errBody,
          };
        } catch {
          return {
            error: true,
            message: "Unable to load receipt preview",
            status_code: response.status,
          };
        }
      }
      return response.blob();
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getReceiptDownload = (user, deposit_payment_id) =>
  oauth2
    .fetch(
      `${api}/client/deposit_payments/${deposit_payment_id}/receipt_download`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSalesUserReceiptPreview = (user, deposit_payment_id) =>
  oauth2
    .fetch(
      `${api}/sales_user/deposit_payments/${deposit_payment_id}/receipt_preview`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then(async (response) => {
      const contentType = (
        response.headers.get("content-type") || ""
      ).toLowerCase();
      if (
        !response.ok ||
        contentType.includes("application/json") ||
        contentType.includes("text/html")
      ) {
        try {
          const errBody = await response.json();
          return {
            error: true,
            message:
              errBody.message ||
              errBody.error ||
              "Unable to load receipt preview",
            status_code: response.status,
            ...errBody,
          };
        } catch {
          return {
            error: true,
            message: "Unable to load receipt preview",
            status_code: response.status,
          };
        }
      }
      return response.blob();
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSalesUserReceiptDownload = (user, deposit_payment_id) =>
  oauth2
    .fetch(
      `${api}/sales_user/deposit_payments/${deposit_payment_id}/receipt_download`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const requestOTPCode = (organizationKey, payload) =>
  oauth2
    .fetch(`${api}/consumer/auth/request_otp`, {
      method: "POST",
      headers: setHeaders(null, false, true, organizationKey),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const verifyAndSignIn = (organizationKey, payload) =>
  oauth2
    .fetch(`${api}/consumer/auth/verify_and_sign_in`, {
      method: "POST",
      headers: setHeaders(null, false, true, organizationKey),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

/** Payment portal: password login. */
export const signInWithPassword = (organizationKey, payload) =>
  oauth2
    .fetch(`${api}/consumer/auth/sign_in_with_password`, {
      method: "POST",
      headers: setHeaders(null, false, true, organizationKey),
      body: JSON.stringify({
        email: payload.email,
        password: payload.password,
      }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSMSTemplateDetail = (user, templateKey) =>
  oauth2
    .fetch(
      `${api}/client/sms/getTemplateDetail?template_key=${encodeURIComponent(
        templateKey
      )}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendSMSPreview = (user, payload) =>
  oauth2
    .fetch(`${api}/client/sms/preview`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const previewSMSText = (user, payload) =>
  oauth2
    .fetch(`${api}/client/sms/previewText`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendSMSToCustomer = (user, payload) =>
  oauth2
    .fetch(`${api}/client/sms/sendSmsManually`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendSMSTextManually = (user, payload) =>
  oauth2
    .fetch(`${api}/client/sms/sendTextManually`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const lookupPhone = (user, phone) =>
  oauth2
    .fetch(`${api}/client/sms/lookupPhone`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ phone }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const getSalesUserSMSTemplateDetail = (user, templateKey) =>
  oauth2
    .fetch(
      `${api}/sales_user/sms/getTemplateDetail?template_key=${encodeURIComponent(
        templateKey
      )}`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((response) => response.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendSalesUserSMSPreview = (user, payload) =>
  oauth2
    .fetch(`${api}/sales_user/sms/preview`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const sendSalesUserSMSToCustomer = (user, payload) =>
  oauth2
    .fetch(`${api}/sales_user/sms/sendSmsManually`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ ...payload }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const lookupSalesUserPhone = (user, phone) =>
  oauth2
    .fetch(`${api}/sales_user/sms/lookupPhone`, {
      method: "POST",
      headers: setHeaders(user, true, true),
      body: JSON.stringify({ phone }),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const activityCommunicationsList = (
  user,
  user_id,
  page = 0,
  filter = "all",
  invoiceIds = [],
  filters = {}
) => {
  const invoiceIdsQuery =
    Array.isArray(invoiceIds) && invoiceIds.length
      ? invoiceIds
          .map((invoiceId) => `&invoice_ids[]=${encodeURIComponent(invoiceId)}`)
          .join("")
      : "";
  const filterPairs = [["customer_name", filters?.customer_name]];
  const filtersQuery = filterPairs
    .filter(([, val]) => val != null && String(val).trim() !== "")
    .map(
      ([key, val]) =>
        `&${encodeURIComponent(key)}=${encodeURIComponent(String(val).trim())}`
    )
    .join("");

  return oauth2
    .fetch(
      `${api}/client/consumers/${user_id}/activity_communications?page=${page}&filter=${encodeURIComponent(filter)}${invoiceIdsQuery}${filtersQuery}`,
      {
        method: "GET",
        headers: setHeaders(user, true, true),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
      throw error;
    });
};

export const getConsumerHierarchy = (user, consumerId) =>
  oauth2
    .fetch(`${api}/client/consumers/${consumerId}/hierarchy`, {
      method: "GET",
      headers: setHeaders(user, true, true),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
    });

export const startCustomerFullResync = (user, userId) =>
  oauth2
    .fetch(`${api}/qb/customers/${encodeURIComponent(userId)}/full_resync`, {
      method: "POST",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
      throw error;
    });

export const getCustomerSyncRun = (user, syncRunId) =>
  oauth2
    .fetch(`${api}/qb/customer_sync_runs/${encodeURIComponent(syncRunId)}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
      throw error;
    });

export const getLatestCustomerSyncRun = (user, userId) =>
  oauth2
    .fetch(
      `${api}/qb/customers/${encodeURIComponent(userId)}/customer_sync_runs/latest`,
      {
        method: "GET",
        headers: setHeaders(user, true, false),
      }
    )
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("error==========:", error);
      throw error;
    });

export const getDebtDocumentFile = (
  user,
  documentId,
  documentSource = "payment_transaction_receipt",
  userId
) => {
  const query = new URLSearchParams();
  query.append("document_id", String(documentId));
  query.append("document_source", documentSource);
  if (userId != null && userId !== "") {
    query.append("user_id", String(userId));
  }

  return oauth2
    .fetch(`${api}/client/debts/document/file?${query.toString()}`, {
      method: "GET",
      headers: setHeaders(user, true, false),
    })
    .then((res) => res.json())
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      console.error("Error fetching debt document file:", error);
      throw error;
    });
};
